<template>
  <div
    v-if="isEmbedded"
    :class="
      concat(
        'plr-frame-control-bar',
        `plr-control-bar__screen_${kebabCase(Screen[activeScreen])}`,
        windowSizePreset ? `${windowSizePreset}` : []
      )
    "
  >
    <button
      v-for="preset of [
        'fullscreen',
        'halfscreen',
        'quarterscreen',
        'initial',
        'minimized'
      ]"
      :class="
        concat(
          'plr-frame-preset-btn',
          `${preset}`,
          preset === windowSizePreset ? 'active' : []
        )
      "
      :key="preset"
      @click="sendParentWindowMessage({ type: 'windowResize', preset })"
    />
    <button @click="handleCloseClick" class="plr-frame-preset-btn close" />
  </div>

  <template v-if="![Screen.failure, Screen.endCall].includes(activeScreen)">
    <div
      @mousemove="restartBottomPanelVisibilityTimer"
      @click="restartBottomPanelVisibilityTimer"
      @mouseleave="localVideoContainerMouseLeavesCount++"
      :class="
        ['call-page-content-container', 'layout_fullscreen']
          .concat(
            activeScreen === Screen.onCall &&
              !isContentHidden &&
              !isKioskType &&
              !isFrameless
              ? ['call-page-content-container--black']
              : []
          )
          .concat(isContentHidden ? ['content-hidden'] : [])
          .concat(
            getProperty('subtitles.enabled') && remoteViewConfig && !isKioskType
              ? ['subtitles-enabled']
              : []
          )
      "
      :style="{
        ...(isFrameless ? {} : { backgroundColor }),
        ...(isKioskType
          ? {
              backgroundImage,
              backgroundPosition: 'top center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }
          : {})
      }"
    >
      <div
        v-if="
          (isKioskType && config?.sessionPageBackgroundDim) ||
            config?.sessionPageBackgroundBlur
        "
        :style="{
          backgroundColor: config?.sessionPageBackgroundDim
            ? `rgba(0, 0, 0, ${config?.sessionPageBackgroundDim})`
            : config?.sessionPageBackgroundBlur
            ? 'rgba(255,255,255, .01)'
            : 'transparent',
          backdropFilter: `blur(${config?.sessionPageBackgroundBlur ?? 0}px)`
        }"
        class="bg-shield"
      />
      <transition name="fade">
        <Header v-if="topicTitle">
          <template v-slot:center>
            <h2 :style="{ color: textColor }" class="noselect">
              {{ topicTitle }}
            </h2>
          </template>
        </Header>
      </transition>
      <div class="call-page-content">
        <transition name="fade">
          <span
            v-if="
              isInteractiveSharingEnabled && !isMobileKeyboardEnabled && false
            "
            class="bottom-panel-button-container keyboard-display-button-container"
          >
            <label for="keyboard-display-textarea">
              <span
                class="bottom-panel-button bottom-panel-button--dark bottom-panel-button--enabled"
                type="button"
              >
                <svg
                  width="44"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      fill="white"
                      d="M460.8,76.8H51.2C23.3,76.8,0,100.1,0,128v256c0,27.9,23.3,51.2,51.2,51.2h409.6
		c27.9,0,51.2-23.3,51.2-51.2V128C512,99.1,488.7,76.8,460.8,76.8z M230.9,153.1h51.2v51.2h-51.2V153.1z M230.9,230.4h51.2v51.2
		h-51.2V230.4z M153.6,153.1h51.2v51.2h-51.2V153.1z M153.6,230.4h51.2v51.2h-51.2V230.4z M128.5,281.6H77.3v-51.2h51.2V281.6z
		 M128.5,204.3H77.3v-51.2h51.2V204.3z M358.4,384H153.6v-51.2h204.8V384z M358.4,281.6h-51.2v-51.2h51.2V281.6z M358.4,204.3h-51.2
		v-51.2h51.2V204.3z M435.7,281.6h-51.2v-51.2h51.2V281.6z M435.7,204.3h-51.2v-51.2h51.2V204.3z"
                    />
                  </g>
                </svg>
              </span>
            </label>
            <span class="bottom-panel-button-title noselect">
              Show keyboard</span
            ></span
          >
          <span
            v-else-if="isInteractiveSharingEnabled && isMobileKeyboardEnabled"
            class="bottom-panel-button-container keyboard-display-button-container"
          >
            <button
              class="bottom-panel-button bottom-panel-button--dark bottom-panel-button--enabled"
              type="button"
            >
              <svg
                width="44"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                xml:space="preserve"
              >
                <g>
                  <path
                    fill="white"
                    d="M460.8,0H51.2C23.3,0,0,23.3,0,51.2v256c0,27.9,23.3,51.2,51.2,51.2h409.6c27.9,0,51.2-23.3,51.2-51.2v-256
		C512,23.3,488.7,0,460.8,0z M230.9,77.3h51.2v51.2h-51.2V77.3z M230.9,153.6h51.2v51.2h-51.2V153.6z M153.6,77.3h51.2v51.2h-51.2
		V77.3z M153.6,153.6h51.2v51.2h-51.2V153.6z M128.5,204.8H77.3v-51.2h51.2V204.8z M128.5,128.5H77.3V77.3h51.2V128.5z M358.4,307.2
		H153.6V256h204.8V307.2z M358.4,204.8h-51.2v-51.2h51.2V204.8z M358.4,128.5h-51.2V77.3h51.2V128.5z M435.7,204.8h-51.2v-51.2h51.2
		V204.8z M435.7,128.5h-51.2V77.3h51.2V128.5z M256,512l102.4-102.4H153.6L256,512z"
                  />
                </g>
              </svg>
            </button>
            <span class="bottom-panel-button-title noselect">
              Hide keyboard</span
            >
          </span>
        </transition>
        <div
          v-if="isKioskType"
          :class="[
            'branding-panel',
            `align_${config.sessionPageBrandingAlignment}`
          ]"
        >
          <span :key="`${appLocale}${timestamp}`" class="head">
            <span>
              {{ moment(timestamp).format("LL") }}
            </span>
            <span>{{ moment(timestamp).format("LT") }}</span>

            <Timer
              v-if="activeScreen === Screen.onCall"
              :timestamp="callStartedAt"
            />
          </span>
          <span class="mid">
            <img
              v-if="config.topPanelImage"
              :src="
                `${
                  startsWith(config.topPanelImage, 'http')
                    ? ''
                    : config.publicPath
                }${config.topPanelImage}`
              "
            />
          </span>
          <span class="tail">
            <span v-if="config?.clientLocation">{{
              config.clientLocation
            }}</span>
          </span>
        </div>

        <template v-if="activeScreen !== Screen.onCall">
          <div
            v-if="!isFrameless"
            :class="{
              'call-page-animation-and-message-container': true,
              'call-page-animation-and-message-container--without-animation':
                activeScreen !== Screen.calling
            }"
          >
            <template v-if="activeScreen === Screen.calling">
              <template v-if="config.sessionLogo">
                <div class="mdr-app-logo-container">
                  <img
                    :src="
                      `${
                        startsWith(config.sessionLogo, 'http')
                          ? ''
                          : config.publicPath
                      }${config.sessionLogo}`
                    "
                    style="max-width: 426px"
                  />
                </div>
                <svg
                  id="esr26fu2s9e1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 317 26"
                  shape-rendering="geometricPrecision"
                  text-rendering="geometricPrecision"
                  width="320"
                  height="30"
                  style="margin-bottom: 15px; margin-top: 15px"
                >
                  <circle
                    :fill="textColor"
                    id="circle_01"
                    r="1"
                    transform="translate(16,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_02"
                    r="1"
                    transform="translate(32,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_03"
                    r="1"
                    transform="translate(48,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_04"
                    r="1"
                    transform="translate(64,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_05"
                    r="1"
                    transform="translate(80,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_06"
                    r="1"
                    transform="translate(96,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_07"
                    r="1"
                    transform="translate(112,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_08"
                    r="1"
                    transform="translate(128,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_09"
                    r="1"
                    transform="translate(144,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_10"
                    r="1"
                    transform="translate(160,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_11"
                    r="1"
                    transform="translate(176,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_12"
                    r="1"
                    transform="translate(192,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_13"
                    r="1"
                    transform="translate(208,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_14"
                    r="1"
                    transform="translate(224,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_15"
                    r="1"
                    transform="translate(240,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_16"
                    r="1"
                    transform="translate(256,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_17"
                    r="1"
                    transform="translate(272,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_18"
                    r="1"
                    transform="translate(288,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                  <circle
                    :fill="textColor"
                    id="circle_19"
                    r="1"
                    transform="translate(304,13) scale(1,1)"
                    fill-opacity="0.66"
                    stroke="none"
                    stroke-width="1"
                  />
                </svg>
              </template>
              <img
                v-else
                :src="require('@/assets/img/callAnimation.svg')"
                alt=""
                class="call-animation"
                role="presentation"
              />

              <div
                v-if="isLocalVideoPreviewVisible"
                class="local-video-preview-container"
              >
                <div class="video-shape">
                  <video
                    ref="localVideoPreviewRef"
                    autoplay=""
                    playsinline=""
                    loop
                    muted
                  />
                </div>
              </div>

              <div
                v-if="
                  isEmbedded &&
                    !isWindowMinimized &&
                    keys(appLocales).length > 1
                "
                class="mdr-clocale-switch"
              >
                <template v-for="(v, k, i) in appLocales" :key="k">
                  <button
                    v-if="i < 3"
                    @click="handleAppLocaleSelect(k)"
                    :class="{ active: k === appLocale }"
                    :style="{ borderColor: textColor, color: textColor }"
                  >
                    {{ v }}
                  </button>
                </template>
                <button v-if="false" class="other" title="Other languages">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="2" :fill="textColor" />
                    <circle cx="18" cy="12" r="2" :fill="textColor" />
                    <circle cx="6" cy="12" r="2" :fill="textColor" />
                  </svg>
                </button>
              </div>
            </template>

            <template v-if="!isWindowMinimized">
              <p
                v-if="primaryMessage && activeScreen === Screen.transferring"
                v-html="primaryMessage"
                :style="{ color: textColor }"
                class="call-primary-message"
              />
              <p
                v-if="secondaryMessage"
                :style="{ color: textColor }"
                class="call-secondary-message"
              >
                {{ secondaryMessage }}
              </p>
              <div
                v-if="isMediaInputsAccessHintVisible"
                class="plr-camera-note"
              >
                <h6>
                  {{ $t("call.mediaInputsAccessNote.title") }}
                </h6>
                <p>
                  {{ $t("call.mediaInputsAccessNote.description") }}
                </p>
              </div></template
            >
          </div>
          <div v-else class="call-page-fancy-animation-container">
            <div class="plr-placing-call-sfx">Please wait...</div>
          </div>
        </template>
        <template v-if="telephonyType !== null">
          <div
            :style="remoteVideoContainerStyleObject"
            :class="{
              'remote-video-container--hidden':
                !(
                  [TelephonyType.webex, TelephonyType.webrtc].includes(
                    telephonyType
                  ) ||
                  (remoteShareVideoStream && !isKioskPortrait)
                ) ||
                activeScreen !== Screen.onCall ||
                isBrowserFrameVisible ||
                !!fullscreenImage,
              'remote-video-container--cover':
                fullscreenImage?.aspectRatio === 'cover' ||
                (aspectRatio === AspectRatioMode.cover &&
                  !isAspectRatioContainForced)
            }"
            class="remote-video-container"
          >
            <template
              v-if="
                (remoteViewConfig || remoteViewCustomBackground?.url) &&
                  !(remoteShareVideoStream && !isKioskPortrait)
              "
            >
              <video
                v-if="
                  remoteViewCustomBackground?.type === 'video' &&
                    remoteViewCustomBackground?.url
                "
                :src="remoteViewCustomBackground?.url"
                :key="remoteViewCustomBackground?.url"
                autoplay
                muted
                loop
              />
              <img
                v-else-if="
                  remoteViewCustomBackground?.url ??
                    remoteViewConfig?.background
                "
                :src="
                  remoteViewCustomBackground?.url ??
                    remoteViewConfig?.background
                "
                :key="
                  remoteViewCustomBackground?.url ??
                    remoteViewConfig?.background
                "
              />

              <RemoteAudioAnimation
                v-if="
                  !isWindowMinimized &&
                    remoteViewConfig?.type === RobotType.voiceOnly
                "
              />
              <AnimatedCharacter
                @state-change="s => (animatedCharacterState = s)"
                v-else-if="
                  remoteViewConfig?.type === RobotType.animatedCharacter
                "
              />
            </template>
            <video
              :style="
                remoteViewConfig?.background &&
                !(remoteShareVideoStream && !isKioskPortrait)
                  ? {
                      zIndex: -1,
                      opacity: 0
                    }
                  : {}
              "
              @resize="handleRemoteVideoResize"
              :muted="
                !isKioskPortrait &&
                  !(
                    telephonyType === TelephonyType.webrtc &&
                    !remoteShareVideoStream
                  )
              "
              ref="remoteVideoRef"
              autoplay=""
              playsinline=""
              loop
            />
          </div>
          <div
            v-if="telephonyType === TelephonyType.twilio"
            ref="remoteVideoContainerRef"
            :class="{
              'remote-video-container--hidden':
                (remoteShareVideoStream && !isKioskPortrait) ||
                activeScreen !== Screen.onCall ||
                isBrowserFrameVisible ||
                !!fullscreenImage,
              'remote-video-container--cover':
                aspectRatio === AspectRatioMode.cover &&
                !isAspectRatioContainForced
            }"
            class="remote-video-container"
          />
          <div
            v-else-if="telephonyType === TelephonyType.zoom"
            :class="{
              'd-none':
                (remoteShareVideoStream && !isKioskPortrait) ||
                activeScreen !== Screen.onCall ||
                isBrowserFrameVisible ||
                !!fullscreenImage
            }"
            class="position-absolute w-100 h-100"
          >
            <video-player-container
              ref="remoteVideoContainerRef"
              class="remote-video-container"
            ></video-player-container>
          </div>

          <div
            v-if="!!fullscreenImage"
            :key="fullscreenImage"
            class="fullscreen-image-container"
          >
            <img
              :src="fullscreenImage.image"
              :class="{
                'fullscreen-image': true,
                'fullscreen-image--cover':
                  aspectRatio === AspectRatioMode.cover &&
                  !isAspectRatioContainForced &&
                  !isLocalVideoFullscreen
              }"
            />
          </div>
        </template>
        <iframe
          v-if="isBrowserFrameVisible"
          :src="openedUrl"
          class="call-page-browser-frame"
          title="Web Browser"
        ></iframe>
        <audio
          v-if="telephonyType === TelephonyType.webex"
          ref="remoteAudioRef"
          autoplay=""
        />
        <!--   Workaround to play audio during screensharing (WebRTC telephony)         -->
        <video
          v-else-if="!isKioskPortrait && telephonyType === TelephonyType.webrtc"
          ref="remoteAudioRef"
          autoplay=""
          class="d-none"
          :muted="false"
        />
        <div
          v-else-if="telephonyType === TelephonyType.twilio"
          ref="remoteAudioContainerRef"
        />
        <video
          v-if="isKioskPortrait && remoteShareVideoStream"
          ref="remoteShareVideoRef"
          :class="{ 'remote-desktop-sharing-on': !!remoteShareVideoStream }"
          class="remote-share-video"
          autoplay=""
          :muted="true"
        />
        <div
          v-if="
            !isFrameless &&
              !isWindowMinimized &&
              sessionInfo?.display_name &&
              activeScreen === Screen.onCall &&
              !(remoteShareVideoStream && !isKioskPortrait)
          "
          class="mdr-expert-name"
        >
          {{ sessionInfo.display_name }}
        </div>
        <div
          v-if="!isBrowserFrameVisible && activeScreen === Screen.onCall"
          aria-hidden="true"
          class="call-page-overlay"
          role="banner"
        />

        <Transition name="fade">
          <VisualHint v-if="visualHint || qrCode" :key="tempHintKey" />
        </Transition>
        <Transition name="fade">
          <TextHint v-if="textHint" :key="tempHintKey" />
        </Transition>
        <Transition name="fade">
          <BulletList v-if="bulletList" :key="tempHintKey" />
        </Transition>
        <Transition name="fade">
          <TableHint v-if="tableHint" :key="tempHintKey" />
        </Transition>
        <VideoHint v-if="videoHint" :key="tempHintKey" />

        <KeepAlive>
          <Subtitles
            v-if="
              activeScreen === Screen.onCall && getProperty('subtitles.enabled')
            "
          />
        </KeepAlive>

        <!-- AGENT IS LISTENING OR THINKING -->
        <Transition name="conversation">
          <div
            v-if="['listening', 'thinking'].includes(animatedCharacterState)"
            :key="animatedCharacterState"
            class="robot-conversation-status"
          >
            <img
              v-if="animatedCharacterState === 'listening'"
              src="@/assets/img/ico-listening.png"
              class="ico-86"
            />
            <img v-else src="@/assets/img/ico-thinking.png" class="ico-86" />
            <h3>
              {{ $t(`call.animatedCharacter.${animatedCharacterState}.title`) }}
            </h3>
            <p>
              {{
                $t(
                  `call.animatedCharacter.${animatedCharacterState}.description`
                )
              }}
            </p>
          </div>
        </Transition>
        <!-- -------------------- -->

        <div
          class="local-video-drag-area"
          :class="{
            'local-video-drag-area--hidden':
              isWindowMinimized ||
              activeScreen !== Screen.onCall ||
              (remoteShareVideoStream && !isKioskPortrait) ||
              isBrowserFrameVisible ||
              (!isSelfViewVisible && activeCameraType !== 'back') ||
              !!fullscreenImage
          }"
          role="presentation"
        >
          <Draggable
            :container-mouse-leaves-count="localVideoContainerMouseLeavesCount"
            :is-active="!isLocalVideoFullscreen"
            :class="{
              'local-video-container--rtl': isRtl,
              'local-video-container--fullscreen': isLocalVideoFullscreen,
              'local-video-container--camera-disabled': !isCameraEnabled
            }"
            class="local-video-container"
          >
            <div
              v-if="
                [TelephonyType.webex, TelephonyType.webrtc].includes(
                  telephonyType
                )
              "
              class="local-video-container-inner"
            >
              <video
                ref="localVideoRef"
                autoplay=""
                playsinline=""
                loop
                muted
              ></video>
            </div>
            <div
              v-else-if="
                [TelephonyType.twilio, TelephonyType.zoom].includes(
                  telephonyType
                )
              "
              ref="localVideoContainerRef"
              class="local-video-container-inner"
            />

            <button
              @click="
                () =>
                  isCameraEnabled
                    ? handleCameraDisableClick()
                    : handleCameraEnableClick()
              "
              :disabled="isVideoOn !== isCameraEnabled"
              :class="
                ['mdr-camera-switch', isCameraEnabled ? 'on' : 'off'].concat(
                  isLocalVideoFullscreen ? ['d-none'] : []
                )
              "
            />
          </Draggable>
          <LocalVideoFullscreenButton
            v-if="isCameraEnabled && activeCameraType === 'back'"
            :is-fullscreen="isLocalVideoFullscreen"
            @click.stop="isLocalVideoFullscreen = !isLocalVideoFullscreen"
            @mousemove.stop="() => null"
          />
        </div>

        <Suggestions v-if="suggestions" />
      </div>
      <textarea
        v-if="isInteractiveSharingEnabled && false"
        v-model="mobileKeyboardInputValue"
        :key="inputKey"
        @input="handleMobileKeyboardInput"
        @focusin="isMobileKeyboardEnabled = true"
        @focusout="isMobileKeyboardEnabled = false"
        type="text"
        id="keyboard-display-textarea"
      />
      <span :key="documentInputKey" class="file-input-container">
        <input
          @change="handleDocumentInputChange"
          :disabled="activeScreen !== Screen.onCall"
          ref="documentInputRef"
          type="file"
          id="document-input"
          accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
        />
      </span>

      <RecordTranslator v-if="activeScreen === Screen.onCall" />

      <transition name="fade">
        <div
          v-if="!isWindowMinimized && (isKioskType || isBottomPanelVisible)"
          class="bottom-panel"
          :class="{
            'bottom-panel--rtl': isRtl,
            'placing-call': activeScreen !== Screen.onCall
          }"
        >
          <span
            class="bottom-panel-left-side"
            :class="{ 'bottom-panel-left-side--rtl': isRtl }"
          >
            <span
              v-if="isKioskType && isCameraToggleButtonVisible"
              class="bottom-panel-button-container"
            >
              <button
                @click="
                  () =>
                    isCameraEnabled
                      ? handleCameraDisableClick()
                      : handleCameraEnableClick()
                "
                :disabled="isVideoOn !== isCameraEnabled"
                :class="
                  ['bottom-panel-button', 'btn-camera-on-off'].concat([
                    isCameraEnabled
                      ? 'bottom-panel-button--dark'
                      : 'bottom-panel-button--light'
                  ])
                "
              />
            </span>
            <span
              v-if="isMicrophoneModeButtonVisible"
              class="bottom-panel-button-container"
            >
              <button
                @click="handleSwitchMicrophoneModeClick"
                :disabled="!isMicModeButtonEnabled"
                :class="
                  ['bottom-panel-button', 'mic-button'].concat([
                    isMicrophoneEnabled
                      ? 'bottom-panel-button--dark'
                      : 'bottom-panel-button--light'
                  ])
                "
                type="button"
              >
                <svg
                  v-if="!isMicrophoneEnabled"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.7849 3.96669L23.3895 20.6024C23.462 20.2462 23.5 19.8776 23.5 19.5V7.5C23.5 4.46243 21.0376 2 18 2C16.3076 2 14.7938 2.76436 13.7849 3.96669ZM19.9497 24.6444L12.5 11.7412V19.5C12.5 22.5376 14.9624 25 18 25C18.6865 25 19.3437 24.8742 19.9497 24.6444Z"
                    fill="black"
                  />
                  <path
                    d="M9.5 14V19.5C9.5 24.1944 13.3056 28 18 28V28M18 28V28C22.6944 28 26.5 24.1944 26.5 19.5V14M18 28V34.5M13.5 34.5H22.5"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 2.5L28 33.5"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>

                <svg
                  v-else
                  fill="none"
                  height="36"
                  viewBox="0 0 36 36"
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    fill="white"
                    height="23"
                    rx="5.5"
                    width="11"
                    x="12.5"
                    y="2"
                  ></rect>
                  <path
                    d="M9.5 14V19.5C9.5 24.1944 13.3056 28 18 28V28M18 28V28C22.6944 28 26.5 24.1944 26.5 19.5V14M18 28V34.5M13.5 34.5H22.5"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-width="2"
                  ></path>
                </svg></button
              ><span
                class="bottom-panel-button-title noselect"
                :class="{
                  'bottom-panel-button-title--disabled': !isMicModeButtonEnabled
                }"
                >{{
                  $t(`call.${isMicrophoneEnabled ? "mute" : "unmute"}`)
                }}</span
              ></span
            >
          </span>
          <span class="bottom-panel-center-side"
            ><span class="bottom-panel-button-container"
              ><button
                @click="
                  activeScreen === Screen.onCall
                    ? (isHangupRequestVisible = true)
                    : handleHangupClick()
                "
                :disabled="!isHangupButtonEnabled"
                class="bottom-panel-button hangup-button bottom-panel-button--red"
                type="button"
              >
                <svg
                  v-if="
                    activeScreen === Screen.onCall && !isHangupRequestVisible
                  "
                  fill="none"
                  height="12"
                  viewBox="0 0 38 12"
                  width="38"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M37.258 11.4377C37.7171 11.0729 37.9733 10.5468 38 9.92322V7.00457C37.9947 6.10946 37.6263 5.30768 36.9003 4.62045C35.8861 3.67019 34.5569 2.9278 32.5924 2.21511C29.5016 1.08244 26.1332 0.416409 22.0121 0.110969C17.0262 -0.236892 12.1524 0.233994 7.52418 1.5109C5.80527 1.99451 3.58992 2.71145 1.76959 3.98836C1.66282 4.06472 1.5614 4.14532 1.47065 4.21744C0.435035 5.04043 -0.040067 5.98644 0.00263859 7.10639L0.00263993 7.12336L0.00797553 7.14457C0.0666958 7.68333 0.0346683 9.43961 0.0346683 9.43961C0.0346683 9.43961 0.0400067 9.68141 0.0453449 9.80444C0.0666977 10.4662 0.312255 10.9923 0.787355 11.3698C1.27313 11.7559 1.94041 11.9468 2.77851 11.9425L8.66121 11.9425C9.42991 11.968 10.1132 11.7728 10.5883 11.3953C11.0581 11.022 11.3036 10.4874 11.3036 9.84262V6.94094C11.3036 6.81367 11.3196 6.69065 11.4371 6.59732C11.4744 6.56763 11.5332 6.52944 11.6613 6.49551C11.6773 6.49126 11.704 6.48702 11.7307 6.48278C12.0136 6.42763 12.3019 6.35127 12.6061 6.27067C12.9051 6.19431 13.2147 6.10947 13.519 6.05432C16.2041 5.57495 19.0494 5.46889 22.2309 5.73191L22.2897 5.73615C23.9979 5.89735 25.2897 6.1434 26.4535 6.5252L26.4748 6.53369C26.7524 6.65247 26.8325 6.72459 26.8325 6.97064V6.9876C26.7844 7.67909 26.7791 8.33663 26.7951 9.10447C26.7898 9.26992 26.7951 9.43536 26.7951 9.59657C26.7951 9.67293 26.7951 9.75777 26.7951 9.83413C26.7951 10.5129 27.03 11.0474 27.5051 11.425C27.9802 11.8025 28.6528 11.9892 29.5069 11.9892C29.5069 11.9892 34.765 12.0104 35.3843 11.9934H35.395C36.1316 12.0104 36.7882 11.811 37.258 11.4377Z"
                    fill="white"
                  />
                </svg>
                <svg
                  v-else
                  fill="none"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 2L2 22M2 2L22 22"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-width="4"
                  ></path>
                </svg></button
              ><span
                :class="{
                  'bottom-panel-button-title--disabled': !isHangupButtonEnabled
                }"
                class="bottom-panel-button-title noselect"
                >{{
                  $t(
                    activeScreen === Screen.onCall ? "call.end" : "call.cancel"
                  )
                }}
              </span></span
            ></span
          >
          <span
            class="bottom-panel-right-side"
            :class="{ 'bottom-panel-right-side--rtl': isRtl }"
          >
            <span
              v-if="isSettingsButtonVisible"
              class="bottom-panel-button-container"
            >
              <button
                @click="isSettingsModalVisible = true"
                class="bottom-panel-button settings-button bottom-panel-button--dark"
                type="button"
              >
                <svg
                  width="38"
                  height="38"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.02731 5.73283L8.85688 6.88816C9.39089 6.55911 9.98037 6.3114 10.608 6.16229L11.0848 4.05178C11.3851 4.01758 11.6905 4 12 4C12.3095 4 12.6149 4.01758 12.9152 4.05178L13.392 6.16229C14.0196 6.3114 14.6091 6.55911 15.1431 6.88816L16.9727 5.73283C17.4519 6.11357 17.8864 6.54811 18.2672 7.02731L17.1118 8.85688C17.4409 9.39089 17.6886 9.98037 17.8377 10.608L19.9482 11.0848C19.9824 11.3851 20 11.6905 20 12C20 12.3095 19.9824 12.6149 19.9482 12.9152L17.8377 13.392C17.6886 14.0196 17.4409 14.6091 17.1118 15.1431L18.2672 16.9727C17.8864 17.4519 17.4519 17.8864 16.9727 18.2672L15.1431 17.1118C14.6091 17.4409 14.0196 17.6886 13.392 17.8377L12.9152 19.9482C12.6149 19.9824 12.3095 20 12 20C11.6905 20 11.3851 19.9824 11.0848 19.9482L10.608 17.8377C9.98037 17.6886 9.39089 17.4409 8.85688 17.1118L7.02731 18.2672C6.54811 17.8864 6.11357 17.4519 5.73283 16.9727L6.88816 15.1431C6.55911 14.6091 6.3114 14.0196 6.16229 13.392L4.05178 12.9152C4.01758 12.6149 4 12.3095 4 12C4 11.6905 4.01758 11.3851 4.05178 11.0848L6.16229 10.608C6.3114 9.98037 6.55911 9.39089 6.88816 8.85688L5.73283 7.02731C6.11357 6.54811 6.54811 6.11357 7.02731 5.73283ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="white"
                    stroke-width="1.5"
                  />
                </svg>
              </button>
            </span>
            <template v-if="isKioskType">
              <span class="bottom-panel-button-container">
                <button
                  @click="
                    aspectRatio =
                      aspectRatio === AspectRatioMode.contain
                        ? AspectRatioMode.cover
                        : AspectRatioMode.contain
                  "
                  class="bottom-panel-button btn-aspect-switch bottom-panel-button--dark"
                ></button>
              </span>
              <span class="bottom-panel-button-container">
                <button
                  @click="isSelfViewVisible = !isSelfViewVisible"
                  :class="
                    [
                      'bottom-panel-button',
                      'btn-self-view-switch',
                      'bottom-panel-button--dark'
                    ].concat([isSelfViewVisible ? '' : 'off'])
                  "
                  :disabled="!isCameraEnabled || cameras?.length < 1"
                />
              </span>
            </template>
          </span>
        </div>
      </transition>

      <div
        v-if="config.envMode === 'staging'"
        class="call-page-test-buttons-container"
        :class="{ 'call-page-test-buttons-container--rtl': isRtl }"
      >
        <template v-if="activeScreen === Screen.onCall">
          <button
            @click="setTestLocalAndRemoteVideos"
            class="call-page-test-button"
          >
            Set local and remote videos
          </button>
          <button
            @click="setTestRemoteViewConfig"
            class="call-page-test-button"
          >
            Set remote view config
          </button>
          <button
            @click="setTestSharedScreenVideo"
            class="call-page-test-button"
          >
            Emulate screen sharing
          </button>
          <button
            @click="openUrl('https://www.youtube.com/embed/fRh_vgS2dFE')"
            class="call-page-test-button"
          >
            Open url
          </button>
          <button @click="setTestVisualHint" class="call-page-test-button">
            Set visual hint
          </button>
          <button @click="setTestTextHint" class="call-page-test-button">
            Set text hint
          </button>
          <button @click="setTestBulletList" class="call-page-test-button">
            Set bullet list
          </button>
          <button @click="setTestTableHint" class="call-page-test-button">
            Set table hint
          </button>
          <button @click="setTestVideoHint" class="call-page-test-button">
            Set video hint
          </button>
          <button @click="setTestSuggestions" class="call-page-test-button">
            Set suggestions
          </button>
          <button @click="setTestSubtitles" class="call-page-test-button">
            Set test subtitles
          </button>
          <button
            @click="handleShowTextMessageFormClick"
            class="call-page-test-button"
          >
            Show text message form
          </button>
          <button
            @click="handleShowPaintoverClick"
            class="call-page-test-button"
          >
            Show paintover
          </button>
        </template>
      </div>

      <template
        v-if="activeScreen === Screen.onCall && !isReconnectingScreenVisible"
      >
        <div v-if="isCameraSnapshotButtonVisible" class="plr-take-photo">
          <button
            @click="handleTakeCameraSnapshotClick"
            :title="$t('call.cameraSnapshot.title')"
          />
        </div>
        <div
          v-if="
            isLocalVideoFullscreen &&
              !isWindowMinimized &&
              !isBottomPanelVisible
          "
          class="bottom-panel"
        >
          <span class="bottom-panel-center-side">
            <span class="bottom-panel-button-container">
              <button
                @click.stop="isHangupRequestVisible = true"
                @mousemove.stop="() => null"
                :disabled="!isHangupButtonEnabled"
                class="bottom-panel-button hangup-button bottom-panel-button--red"
                type="button"
              >
                <svg
                  fill="none"
                  height="12"
                  viewBox="0 0 38 12"
                  width="38"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M37.258 11.4377C37.7171 11.0729 37.9733 10.5468 38 9.92322V7.00457C37.9947 6.10946 37.6263 5.30768 36.9003 4.62045C35.8861 3.67019 34.5569 2.9278 32.5924 2.21511C29.5016 1.08244 26.1332 0.416409 22.0121 0.110969C17.0262 -0.236892 12.1524 0.233994 7.52418 1.5109C5.80527 1.99451 3.58992 2.71145 1.76959 3.98836C1.66282 4.06472 1.5614 4.14532 1.47065 4.21744C0.435035 5.04043 -0.040067 5.98644 0.00263859 7.10639L0.00263993 7.12336L0.00797553 7.14457C0.0666958 7.68333 0.0346683 9.43961 0.0346683 9.43961C0.0346683 9.43961 0.0400067 9.68141 0.0453449 9.80444C0.0666977 10.4662 0.312255 10.9923 0.787355 11.3698C1.27313 11.7559 1.94041 11.9468 2.77851 11.9425L8.66121 11.9425C9.42991 11.968 10.1132 11.7728 10.5883 11.3953C11.0581 11.022 11.3036 10.4874 11.3036 9.84262V6.94094C11.3036 6.81367 11.3196 6.69065 11.4371 6.59732C11.4744 6.56763 11.5332 6.52944 11.6613 6.49551C11.6773 6.49126 11.704 6.48702 11.7307 6.48278C12.0136 6.42763 12.3019 6.35127 12.6061 6.27067C12.9051 6.19431 13.2147 6.10947 13.519 6.05432C16.2041 5.57495 19.0494 5.46889 22.2309 5.73191L22.2897 5.73615C23.9979 5.89735 25.2897 6.1434 26.4535 6.5252L26.4748 6.53369C26.7524 6.65247 26.8325 6.72459 26.8325 6.97064V6.9876C26.7844 7.67909 26.7791 8.33663 26.7951 9.10447C26.7898 9.26992 26.7951 9.43536 26.7951 9.59657C26.7951 9.67293 26.7951 9.75777 26.7951 9.83413C26.7951 10.5129 27.03 11.0474 27.5051 11.425C27.9802 11.8025 28.6528 11.9892 29.5069 11.9892C29.5069 11.9892 34.765 12.0104 35.3843 11.9934H35.395C36.1316 12.0104 36.7882 11.811 37.258 11.4377Z"
                    fill="white"
                  />
                </svg>
              </button>
            </span>
          </span>
        </div>
      </template>
    </div>
    <template v-if="!isContentHidden">
      <transition name="fade">
        <modal
          v-if="isHangupRequestVisible"
          @close="isHangupRequestVisible = false"
          :position="ModalPosition.center"
          :size="ModalSize.sm"
          class="hangup-modal"
        >
          <template v-slot:header>
            <h2 class="hangup-request-title">
              {{ $t("call.hangupRequest.title") }}
            </h2>
          </template>
          <template v-slot:body>
            <p class="hangup-request-paragraph">
              {{ $t("call.hangupRequest.body") }}
            </p>
          </template>
          <template v-slot:footer>
            <div class="hangup-request-buttons-container">
              <modal-button
                @click="handleHangupClick"
                :text="$t('call.hangupRequest.yes')"
                :type="ButtonType.primary"
              />
              <modal-button
                @click="isHangupRequestVisible = false"
                :text="$t('call.hangupRequest.no')"
                :type="ButtonType.secondary"
              />
            </div>
          </template>
        </modal>
      </transition>
      <transition name="fade">
        <modal
          v-if="isOpenUrlRequestVisible"
          @close="isOpenUrlRequestVisible = false"
          :position="ModalPosition.center"
          :size="ModalSize.sm"
        >
          <template v-slot:header>
            <h2 class="open-url-request-title">
              {{ $t("call.openUrlRequest.title") }}
            </h2>
          </template>
          <template v-slot:body>
            <p class="open-url-request-paragraph">
              {{ $t("call.openUrlRequest.body") }}
            </p>
          </template>
          <template v-slot:footer>
            <div class="open-url-request-buttons-container">
              <modal-button
                @click="isOpenUrlRequestVisible = false"
                :text="$t('call.openUrlRequest.no')"
                :type="ButtonType.secondary"
              />
              <modal-button
                @click="openUrl('' + openedUrl)"
                :text="$t('call.openUrlRequest.yes')"
                :type="ButtonType.primary"
              />
            </div>
          </template>
        </modal>
      </transition>
      <transition name="fade">
        <modal
          v-if="isLowPerformanceModalVisible"
          @close="isLowPerformanceModalVisible = false"
          :position="ModalPosition.center"
          :size="ModalSize.sm"
        >
          <template v-slot:header>
            <h2 class="hangup-request-title">
              {{ $t("call.lowPerformanceNotification.title") }}
            </h2>
          </template>
          <template v-slot:body>
            <div class="more-actions-modal-buttons-container">
              <modal-button
                @click="isLowPerformanceModalVisible = false"
                :text="$t('call.lowPerformanceNotification.gotIt')"
                :type="ButtonType.primary"
              />
            </div>
          </template>
        </modal>
      </transition>
      <transition name="fade">
        <modal
          v-if="
            find(
              requestedRemoteActions,
              v => v.action === RequestedAction.showFileRequest
            )
          "
          @close="
            handleRemoteActionRequestReject(RequestedAction.showFileRequest)
          "
          :position="ModalPosition.center"
          :size="ModalSize.sm"
        >
          <template v-slot:header>
            <h2 :dir="isRtl ? 'rtl' : 'ltr'" class="hangup-request-title">
              {{ $t("call.remoteActionRequest.shareFile.title") }}
            </h2>
          </template>
          <template v-slot:body> </template>
          <template v-slot:footer>
            <div class="open-url-request-buttons-container">
              <modal-button
                @click="
                  handleRemoteActionRequestApprove(
                    RequestedAction.showFileRequest
                  )
                "
                :text="$t('call.remoteActionRequest.shareFile.yes')"
                :type="ButtonType.primary"
              />
              <modal-button
                @click="
                  handleRemoteActionRequestReject(
                    RequestedAction.showFileRequest
                  )
                "
                :text="$t('call.remoteActionRequest.shareFile.no')"
                :type="ButtonType.secondary"
              />
            </div>
          </template>
        </modal>
      </transition>
      <transition name="fade">
        <modal
          v-if="
            find(
              requestedRemoteActions,
              v => v.action === RequestedAction.startScreenSharing
            )
          "
          @close="
            handleRemoteActionRequestReject(RequestedAction.startScreenSharing)
          "
          :position="ModalPosition.center"
          :size="ModalSize.sm"
        >
          <template v-slot:header>
            <h2 :dir="isRtl ? 'rtl' : 'ltr'" class="hangup-request-title">
              {{ $t("call.remoteActionRequest.screenSharing.title") }}
            </h2>
          </template>
          <template v-slot:body> </template>
          <template v-slot:footer>
            <div class="open-url-request-buttons-container">
              <modal-button
                @click="
                  handleRemoteActionRequestApprove(
                    RequestedAction.startScreenSharing
                  )
                "
                :text="$t('call.remoteActionRequest.screenSharing.yes')"
                :type="ButtonType.primary"
              />
              <modal-button
                @click="
                  handleRemoteActionRequestReject(
                    RequestedAction.startScreenSharing
                  )
                "
                :text="$t('call.remoteActionRequest.screenSharing.no')"
                :type="ButtonType.secondary"
              />
            </div>
          </template>
        </modal>
      </transition>
      <transition name="fade">
        <KeepAlive v-if="activeScreen === Screen.onCall">
          <modal
            v-if="
              find(
                requestedRemoteActions,
                v => v.action === RequestedAction.showTextMessageForm
              )
            "
            @close="
              handleRemoteActionRequestReject(
                RequestedAction.showTextMessageForm
              )
            "
            :close-button-visible="true"
            :position="ModalPosition.center"
            :size="ModalSize.sm"
            class="plr-text-message-form"
          >
            <template v-slot:body>
              <TextMessageForm />
            </template> </modal
        ></KeepAlive>
      </transition>
      <transition name="fade">
        <modal
          v-if="isSettingsModalVisible"
          @close="isSettingsModalVisible = false"
          :close-button-visible="true"
          :position="ModalPosition.center"
          :size="ModalSize.sm"
          class="mdr-device-select"
        >
          <template v-slot:header>
            <h2>
              {{ $t("call.settings.title") }}
            </h2>
          </template>
          <template v-slot:body>
            <modal-button
              v-if="remoteViewConfig?.type !== RobotType.animatedCharacter"
              @click="
                aspectRatio =
                  aspectRatio === AspectRatioMode.contain
                    ? AspectRatioMode.cover
                    : AspectRatioMode.contain
              "
              :disabled="isAspectRatioContainForced"
              :text="$t('call.aspectRatio')"
              :type="ButtonType.secondary"
            />

            <template v-if="!!cameras?.length">
              <h6>{{ $t("call.settings.labels.camera") }}</h6>

              <select
                v-if="cameras.length > 1"
                v-model="cameraId"
                :disabled="!isVideoOn || !isCameraEnabled"
              >
                <option
                  v-for="c in cameras"
                  :value="c.camera.deviceId"
                  :key="c.camera.deviceId"
                >
                  {{ c.camera.label }}
                </option>
              </select>

              <modal-button
                v-if="isCameraToggleButtonVisible"
                @click="
                  () =>
                    isCameraEnabled
                      ? handleCameraDisableClick()
                      : handleCameraEnableClick()
                "
                :text="
                  $t(
                    isCameraEnabled
                      ? 'call.camera.disable'
                      : 'call.camera.enable'
                  )
                "
                :disabled="isCameraEnabled !== isVideoOn"
                :type="ButtonType.secondary"
              />
            </template>

            <template v-if="microphones?.length > 1">
              <h6>{{ $t("call.settings.labels.microphone") }}</h6>
              <select v-model="microphoneId" :disabled="!isMicrophoneEnabled">
                <option
                  v-for="m in microphones"
                  :value="m.microphone.deviceId"
                  :key="m.microphone.deviceId"
                >
                  {{ m.microphone.label }}
                </option>
              </select>
            </template>

            <modal-button
              v-if="isCallSharingButtonVisible && false"
              @click="handleCallSharingClick"
              :text="$t('call.share')"
              :type="ButtonType.secondary"
            />
          </template>
        </modal>
      </transition>
    </template>

    <template
      v-if="
        find(requestedRemoteActions, {
          action: RequestedAction.showDrawingPad
        })
      "
    >
      <Paintover
        v-if="
          find(requestedRemoteActions, {
            action: RequestedAction.showDrawingPad
          })?.payload?.background?.url
        "
        v-show="!isContentHidden"
      />
      <SignaturePad v-else v-show="!isContentHidden" />
    </template>

    <OnHold v-if="isOnHold && !isContentHidden" />

    <div
      :class="[
        'mdr-session-restore-curtains',
        isReconnectingScreenVisible ? 'show' : 'hide'
      ]"
    >
      <div class="top">
        <h1>
          {{ $t("error.connection.title", [true]) }}
        </h1>
      </div>
      <div class="animation-container">
        <div class="progress-animation">
          <div class="mdr-circle">
            <div class="full mdr-progress-circle__slice">
              <div class="mdr-progress-circle__fill"></div>
            </div>
            <div class="mdr-progress-circle__slice">
              <div class="mdr-progress-circle__fill"></div>
              <div
                class="mdr-progress-circle__fill mdr-progress-circle__bar"
              ></div>
            </div>
          </div>
          <img :src="require('@/assets/img/expert-photo.png')" />
        </div>
      </div>
      <div class="bottom">
        <h3>
          {{ $t("error.connection.description", [true]) }}
        </h3>
      </div>
    </div>
  </template>
  <div
    v-else
    :class="
      ['feedback-page-content-container', 'layout_fullscreen'].concat(
        isContentHidden ? ['content-hidden'] : []
      )
    "
    :style="{
      ...{ backgroundColor },
      ...(isKioskType
        ? {
            backgroundImage,
            backgroundPosition: 'top center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }
        : {})
    }"
  >
    <h1
      v-if="primaryMessage"
      v-html="primaryMessage"
      :class="
        activeScreen === Screen.endCall && config.feedbackEnabled
          ? 'page-title'
          : 'thank-page-title'
      "
      :style="{ color: textColor }"
    />
    <ul
      v-if="activeScreen === Screen.endCall && config.feedbackEnabled"
      :class="{
        'feedback-options': true,
        stars: config?.feedbackAppearance === 'stars'
      }"
    >
      <li>
        <button
          v-for="r of range(1, 5 + 1)"
          :key="r"
          :disabled="!jwt || isFeedbackCreating"
          @click="handleFeedbackClick(r)"
          :class="['rate', `rate-${r}`]"
        />
      </li>
    </ul>
    <button
      v-if="!isEmbedded"
      @click="$emit(redirectTo ? 'redirect' : 'toTopics')"
      :style="{
        background: config.secondaryButtonColor,
        color: config.secondaryButtonTextColor
      }"
      class="thank-page-link"
    >
      {{ $t(redirectTo ? "thank.redirect" : "thank.toTopics") }}
    </button>
    <button
      v-if="isFeedbackFormEnabled && !isFeedbackFormVisible"
      @click="isFeedbackFormVisible = true"
      class="btn-feedback-msg"
    >
      {{ $t("feedback.form.buttons.open") }}
    </button>

    <FeedbackForm
      v-if="isFeedbackFormVisible"
      @done="isFeedbackFormVisible = false"
      @cancel="isFeedbackFormVisible = false"
    />
  </div>
  <div
    v-if="sharedFile"
    :class="[
      'justify-content-center',
      isSharedFileModalVisible && !isContentHidden ? 'd-flex' : 'd-none'
    ]"
  >
    <div class="mdr-warning borderless danger bottom">
      <div class="body">
        <h3>{{ $t("call.downloadFileRequest.title") }}</h3>
      </div>
      <div class="action">
        <a
          v-if="isSafari"
          @click="handleSharedFileDownloadClick"
          :href="sharedFileLink"
          target="_blank"
          class="btn btn-primary"
          >{{ $t("call.downloadFileRequest.yes") }}</a
        >
        <a
          v-else
          :href="sharedFileLink"
          @click="handleSharedFileDownloadClick"
          :download="
            startsWith(sharedFile.mimeType, 'image/')
              ? `Received image.${mime.extension(sharedFile.mimeType)}`
              : `Received file.${mime.extension(sharedFile.mimeType)}`
          "
          class="btn btn-primary"
          >{{ $t("call.downloadFileRequest.yes") }}</a
        >
        <button
          @click="handleSharedFileDismissClick"
          class="btn btn-secondary"
          type="button"
          name="button"
        >
          {{ $t("call.downloadFileRequest.no") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useStore } from "vuex";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
  watchEffect
} from "vue";
import {
  AcquireFailedRequestReason,
  AspectRatioMode,
  AuthenticatableType,
  HumanSpeechLanguage,
  BulletListDto,
  TableHintDto,
  CallQueuePositionChangedReason,
  ClientAppType,
  ColibriLanguage,
  EndpointStatus,
  EndpointStatusDetails,
  MessageType,
  RemoteViewConfigDto,
  RemoteViewCustomBackground,
  RequestedAction,
  RobotType,
  RoomDTO,
  SessionInfo,
  TelephonyType,
  TopicDTO,
  VideoHintDto,
  DeviceType,
  QrCodeDTO,
  TextHintDto
} from "@moderrotech/servers-communication-library/src/types";
import { useRoute, useRouter } from "vue-router";
import Header from "@/components/Header.vue";
import Draggable from "@/components/Draggable.vue";
import Modal, { ModalPosition, ModalSize } from "@/components/Modal.vue";
import ModalButton, { ButtonType } from "@/components/ModalButton.vue";
import { AppLocale, i18n } from "@/lang";
import _ from "lodash";
import { isLangRtl } from "@moderrotech/servers-communication-library/src/helpers/lang";
import {
  showFailedRequestToastError,
  showToastError,
  showToastSuccess
} from "@/helpers/notification";
import VisualHint from "@/components/VisualHint.vue";
import TextHint from "@/components/TextHint.vue";
import OnHold from "@/components/OnHold.vue";
import LocalVideoFullscreenButton from "@/components/LocalVideoFullscreenButton.vue";
import TextMessageForm from "@/components/TextMessageForm.vue";
import SignaturePad from "@/components/SignaturePad.vue";
import moment from "moment";
/* eslint-disable */
// @ts-ignore
import {copyText} from 'vue3-clipboard'
/* eslint-enable */
// eslint-disable-next-line @typescript-eslint/camelcase
import jwt_decode from "jwt-decode";
import mime from "mime-types";
import RecordTranslator from "@/components/RecordTranslator.vue";
import { getColibriLangIndex } from "@moderrotech/servers-communication-library/src/helpers/colibri";
import imageCompression from "browser-image-compression";
import html2canvas from "html2canvas";
import ISO6391 from "iso-639-1";
import {
  listenParentWindowMessages,
  sendParentWindowMessage,
  WindowSizePreset
} from "@/helpers/embedded";
import RemoteAudioAnimation from "@/components/RemoteAudioAnimation.vue";
import FeedbackForm from "@/components/FeedbackForm.vue";
import {
  useIdle,
  useTimestamp,
  useEventListener,
  useCssVar
} from "@vueuse/core";
import BulletList from "@/components/BulletList.vue";
import Suggestions from "@/components/Suggestions.vue";
import Paintover from "@/components/Paintover.vue";
import AnimatedCharacter from "@/components/AnimatedCharacter.vue";
import TableHint from "@/components/TableHint.vue";
import VideoHint from "@/components/VideoHint.vue";
import {
  getDeviceType,
  getUaParserResult
} from "@moderrotech/servers-communication-library/src/helpers/device";
import { BrowserName, OSName } from "ua-parser-js/src/enums/ua-parser-enums";
import Timer from "@/components/Timer.vue";
import { AudioDevicesVolumeDto } from "@moderrotech/servers-communication-library/src/types";
import Subtitles from "@/components/Subtitles.vue";
import { preloadAvatarGlb } from "@/helpers/avatar";

export default {
  components: {
    Subtitles,
    Timer,
    VideoHint,
    TableHint,
    AnimatedCharacter,
    Paintover,
    Suggestions,
    BulletList,
    FeedbackForm,
    RemoteAudioAnimation,
    RecordTranslator,
    SignaturePad,
    TextMessageForm,
    LocalVideoFullscreenButton,
    OnHold,
    TextHint,
    VisualHint,
    ModalButton,
    Modal,
    Draggable,
    Header
  },

  emits: ["toTopics", "hangup", "idle"],

  props: {
    isReconnectingScreenVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    // used to avoid wrong screen displaying according REM data retrieving latency
    isContentHidden: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  setup(props: {}, context: { emit: Function }) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const getProperty = (name: string) => store.getters["auth/property"](name);

    const endpointStatusCode = computed(() => store.getters.endpointStatusCode),
      sessionInfo = computed(
        (): SessionInfo | null => store.state.session.info
      );

    const telephonyType = computed(() => store.state.telephonyType);

    const isKioskOs = computed(() => store.getters["auth/isKioskOs"]),
      isWebKiosk = computed(() => store.getters["auth/isWebKiosk"]);

    type RouteQueryKey =
      | "topic"
      | "room_id"
      | "webex_room_id"
      | "device_id"
      | "context"
      | "foreign_id"
      | "redirect"
      | "login_type"
      | "feedback_payload";

    const getRouteQueryValue = (key: RouteQueryKey) => route.query[key],
      unsetRouteQueryKey = async (keys: RouteQueryKey | RouteQueryKey[]) =>
        await router.replace({
          name: route.name!,
          params: route.params,
          query: _.omit(route.query, keys)
        });

    const metaData = reactive<{
      webexRoomId: string | null;
      deviceId: string | null;
      context: object | null;
    }>({
      webexRoomId: null,
      deviceId: null,
      context: null
    });

    const isMounted = ref(false);

    const deleteLocalMediaStreams = () => {
        console.log("Deleting local media streams...");
        if (telephonyType.value === TelephonyType.webex) {
          ["localVideo", "localAudio"].forEach(v =>
            store.commit("webex/UNSET_STREAM", v)
          );
        } else if (telephonyType.value === TelephonyType.webrtc) {
          store.commit("webrtc/UNSET_STREAM", "local");
        }
        console.log("Deleted local media streams");
      },
      createLocalMediaStreams = async () => {
        const errCb = (err?: Error) => {
          console.error("Can not get media stream(s): ", err);
          store.dispatch("setEndpointStatus", {
            status: EndpointStatus.failure,
            details: EndpointStatusDetails.mediaStreamsCreatingError
          });

          throw err ??
            new Error(EndpointStatusDetails.mediaStreamsCreatingError);
        };

        if (telephonyType.value === TelephonyType.webex) {
          ["localAudio", "localVideo"].forEach(type =>
            store.commit("webex/UNSET_STREAM", type)
          );

          try {
            const { camera, microphone } = await store.dispatch(
              "webex/createMediaStreams",
              {
                camera: true,
                microphone: true
              }
            );
            if (!camera || !microphone) {
              camera?.stop();
              microphone?.stop();
              errCb();
            }

            if (!isMounted.value) {
              deleteLocalMediaStreams();
              return;
            }

            if (!store.state.session.mediaDevices.isCameraEnabled) {
              store.dispatch("session/mediaDevices/disableCamera");
            }
            if (!store.state.session.mediaDevices.isMicrophoneEnabled) {
              store.dispatch("session/mediaDevices/disableMicrophone");
            }
          } catch (err) {
            errCb(err);
          }
        } else if (telephonyType.value === TelephonyType.webrtc) {
          try {
            await store.dispatch("webrtc/createMediaStream");
            if (!isMounted.value) {
              deleteLocalMediaStreams();
              return;
            }
          } catch (err) {
            errCb(err);
          }
        }
      };

    onMounted(() => (isMounted.value = true));

    onUnmounted(() => {
      isMounted.value = false;
      deleteLocalMediaStreams();
    });

    const isThrownFromQueueUrgently = computed(
      () => store.getters["queue/isThrownUrgently"]
    );

    const isThankPageDisplayingForced = computed(() => route.name === "thank");
    const errorMessage = ref<string | null>(null);

    onMounted(async () => {
      if (getRouteQueryValue("webex_room_id")) {
        metaData.webexRoomId = String(getRouteQueryValue("webex_room_id")!);
      }
      if (getRouteQueryValue("device_id")) {
        metaData.deviceId = `{${_.trimStart(
          _.trimEnd(String(getRouteQueryValue("device_id")!), "}"),
          "{"
        )}}`;
      }
      if (getRouteQueryValue("context")) {
        try {
          metaData.context = (jwt_decode(
            String(getRouteQueryValue("context")!)
          ) as {
            payload: object;
          }).payload;
        } catch (e) {
          // encrypted value, not jwt
          metaData.context = {
            encrypted: String(getRouteQueryValue("context")!)
          };
        }
      }

      const clientContext = _.assign(
        {},
        store.state.metadata.customerInfo ?? {},
        metaData.context ?? {}
      );

      const beforeAcquire = async () => {
        if (
          [TelephonyType.webex, TelephonyType.webrtc].includes(
            telephonyType.value
          )
        ) {
          await createLocalMediaStreams();
        }
      };

      watch(
        () =>
          [TelephonyType.webex, TelephonyType.webrtc].includes(
            telephonyType.value
          )
            ? endpointStatusCode.value === EndpointStatus.ready
            : true,
        v => {
          if (v) {
            if (getRouteQueryValue("topic")) {
              console.log(
                "Found topic in URL query: ",
                getRouteQueryValue("topic")
              );

              beforeAcquire().then(() => {
                if (!getRouteQueryValue("topic")) {
                  // already not actual
                  return;
                }

                store.dispatch(
                  "queue/acquire",
                  _.assign(
                    {
                      target: getRouteQueryValue("topic"),
                      foreignId: getRouteQueryValue("foreign_id") ?? "",
                      callback: async () =>
                        await unsetRouteQueryKey(["topic", "foreign_id"]),
                      errorCallback: (err: string) => (errorMessage.value = err)
                    },
                    _.keys(clientContext).length
                      ? { context: clientContext }
                      : {}
                  )
                );
              });
            } else if (getRouteQueryValue("room_id")) {
              store.commit("session/UNSET_ROOM");
              store.dispatch("session/getRoom", {
                callback: (room: RoomDTO) => {
                  if (!room.id) {
                    beforeAcquire().then(() => {
                      if (!getRouteQueryValue("room_id")) {
                        // already not actual
                        return;
                      }
                      store.dispatch(
                        "queue/acquire",
                        _.assign(
                          {
                            target: getRouteQueryValue("room_id")!,
                            foreignId: getRouteQueryValue("foreign_id") ?? "",
                            callback: async () =>
                              await unsetRouteQueryKey([
                                "room_id",
                                "foreign_id"
                              ]),
                            errorCallback: (err: string) =>
                              (errorMessage.value = i18n.global.t(
                                "call.error.noRoom"
                              ))
                          },
                          _.keys(clientContext).length
                            ? { context: clientContext }
                            : {}
                        )
                      );
                    });
                  }
                }
              });
            }
          }
        },
        { immediate: true }
      );
    });

    const config = computed(() => store.state.config.config);

    const sharedLink = ref();

    const queuePosition = computed(() => store.state.queue.position);
    watch(
      () => queuePosition.value >= 0,
      async v => {
        if (v) {
          if (
            (telephonyType.value === TelephonyType.webex &&
              (!store.state.webex.streams.localVideo ||
                !store.state.webex.streams.localAudio)) ||
            (telephonyType.value === TelephonyType.webrtc &&
              !store.state.webrtc.streams.local)
          ) {
            await createLocalMediaStreams();
          }
        }
      }
    );
    watch(
      () =>
        ![EndpointStatus.unknown, EndpointStatus.ready].includes(
          +endpointStatusCode.value
        ),
      async v => {
        if (
          v &&
          [TelephonyType.webex, TelephonyType.webrtc].includes(
            telephonyType.value
          ) &&
          getRouteQueryValue("topic")
        ) {
          await unsetRouteQueryKey("topic");
        }
      }
    );

    watch(
      () =>
        endpointStatusCode.value === EndpointStatus.connected &&
        [TelephonyType.webex, TelephonyType.twilio].includes(
          telephonyType.value
        ),

      async val => {
        if (val) {
          if (telephonyType.value === TelephonyType.webex) {
            const webex = _.get(store, "state.webex.webex");

            const webexRoomId =
              metaData.webexRoomId ??
              _.get(
                (await webex?.rooms?.list({ max: 1 }))?.items ?? [],
                "[0].id",
                "fake-room-id"
              );

            sharedLink.value = encodeURI(
              `${window.location.origin}${config.value.publicPath ??
                "/"}${_.trimStart(
                router.resolve({
                  name: String(route.name),
                  query: {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    webex_room_id: webexRoomId,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    topic:
                      getRouteQueryValue("topic") ??
                      store.state.session.info?.topic,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    device_id: _.trimEnd(
                      _.trimStart(
                        getRouteQueryValue("device_id") ??
                          store.state.auth.deviceId,
                        "{"
                      ),
                      "}"
                    )
                  }
                }).href,
                "/"
              )}`
            );
          }

          await router.replace({
            name: String(route.name),
            params: route.params,
            query: _.assign(
              {},
              getRouteQueryValue("room_id")
                ? // eslint-disable-next-line @typescript-eslint/camelcase
                  { room_id: getRouteQueryValue("room_id")! }
                : {},
              _.pick(route.query, ["redirect", "login_type"])
            )
          });
        }
      }
    );

    onUnmounted(() => {
      if (store.state.session.info) {
        store.commit("session/UNSET_INFO");
      }
    });

    const appLocale = computed((): string => config.value.appLocale);

    const topicTitle = computed(() => {
      if (
        getRouteQueryValue("topic") &&
        store.state.topics.list?.[`${getRouteQueryValue("topic")!}`]
      ) {
        return store.getters["topics/getTitle"]?.(
          store.state.topics.list[`${getRouteQueryValue("topic")!}`],
          appLocale.value
        );
      } else if (!getRouteQueryValue("topic") && sessionInfo.value) {
        return (
          _.find(
            _.map([appLocale, "en", "any"], (l: string | "any") =>
              _.last(
                _.find(
                  sessionInfo.value?.topic_title,
                  v =>
                    _.first(v) ===
                    (l === "any" ? ColibriLanguage.Any : getColibriLangIndex(l))
                )
              )
            ),
            v => !!v
          ) ??
          sessionInfo.value.topic ??
          "unknown"
        );
      }
      return null;
    });

    const aspectRatio = ref<AspectRatioMode>();
    const isBrowserFrameVisible = ref(false);
    const isOpenUrlRequestVisible = ref(false);
    const openedUrl = ref<string>();
    const openUrl = async (url: string) => {
      openedUrl.value = undefined;
      isOpenUrlRequestVisible.value = false;
      isBrowserFrameVisible.value = false;
      const finalUrl = url.includes("://") ? url : `https://${url}`;
      const finalUrlHttps = finalUrl.replace(/^http:/, "https:");
      const iframeable = false;
      if (iframeable) {
        console.debug(`Opening ${finalUrlHttps} in iframe`);
        openedUrl.value = finalUrlHttps;
        isBrowserFrameVisible.value = true;
      } else {
        console.debug(`Opening ${openedUrl.value} in new tab/window`);
        let newWindow = null;
        try {
          newWindow = window.open(finalUrl);
        } catch (err) {
          // nothing
        }
        if (!newWindow) {
          const msg = `window.open("${finalUrl}") failed. Asking for permission`;
          console.debug(msg);
          openedUrl.value = finalUrl;
          isOpenUrlRequestVisible.value = true;
        }
      }
    };
    const setTestVisualHint = () => {
      const prevPosition = store.state.session.visualHint?.position;

      store.commit("session/UNSET_VISUAL_HINT");
      store.commit("session/SET_VISUAL_HINT", {
        id: "6fd0ffca-db77-4631-8369-00de348c377a",
        url: "/staging/img/visual-hint.jpg",
        duration: 5000,
        position: prevPosition === "left" ? "right" : "left"
      });
    };

    const setTestTextHint = () => {
      store.commit("session/SET_TEXT_HINT", {
        id: "40147656-57f6-4e48-a800-68ecefdd1654",
        duration: 5000,
        title: "Text hint",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse nec massa enim. Praesent eu aliquet tortor. Nullam sed euismod lectus. Sed non quam vitae dui molestie mattis eget nec odio. Sed venenatis sodales leo, ut bibendum libero accumsan vitae. Nunc vitae quam odio. Mauris rutrum vestibulum ante, in iaculis augue pulvinar non."
      });
    };

    const setTestBulletList = () =>
      store.commit("session/SET_BULLET_LIST", {
        id: "9209fb73-b23f-41ab-84bd-61df9f5c83d7",
        duration: 5000,
        title: "Topics:",
        clickable: false,
        items: [
          "Accessibility Standards",
          "Prototyping Techniques",
          "Design Systems",
          "Color Theory",
          "Performance Optimization",
          "Accessibility Standards",
          "Prototyping Techniques",
          "Design Systems",
          "Color Theory",
          "Performance Optimization",
          "Accessibility Standards",
          "Prototyping Techniques",
          "Design Systems",
          "Color Theory",
          "Performance Optimization",
          "Accessibility Standards",
          "Prototyping Techniques",
          "Design Systems",
          "Color Theory",
          "Performance Optimization"
        ]
      });

    const setTestTableHint = () =>
      store.commit("session/SET_TABLE_HINT", {
        id: "cc1097c1-8d90-4b06-b109-7c561213ed67",
        duration: 5000,
        title: "My Table title",
        head: ["Model", "Trim", "Year", "Engine", "Transmission", "Color"],
        rows: _.map(_.range(6), i => [
          "Toyota Camry",
          "Comfort + multimedia, leather interior, rear view camera",
          "2022",
          "Engine 2.0 L",
          "Automatic Transmission",
          "Deep Navy, metallic"
        ])
      });

    const setTestVideoHint = () =>
      store.commit("session/SET_VIDEO_HINT", {
        id: "659ac0a5-63cd-47fe-b52c-8e6b4dadaf3f",
        title: "Video title",
        url:
          "https://upload.wikimedia.org/wikipedia/commons/f/f1/Sintel_movie_4K.webm",
        // url: "https://www.moderro.com/kiosk-video/Eiffel-tower-portrait.mp4",
        size: "normal",
        // size: "small",
        muted: false,
        showControls: true
      } as VideoHintDto);

    const setTestSuggestions = () =>
      store.commit("session/SET_SUGGESTIONS", ["Male", "Female", "Unknown"]);

    const setTestSubtitles = () =>
      store.commit("session/SET_SUBTITLES", [
        ["Hello, ", +moment().subtract(1, "s")],
        ["world", +moment()]
      ]);

    const windowSizePreset = ref<WindowSizePreset>(),
      windowSizeBackPreset = ref<WindowSizePreset | null>(), // used to resize window to minimized preset if hint was received during minimized preset and preset size was changed to display the hint
      isWindowMinimized = computed(
        () => windowSizePreset.value === "minimized"
      );
    watch(
      () => [
        windowSizePreset.value,
        endpointStatusCode.value === EndpointStatus.connected &&
          store.state.network.status === "connected"
      ],
      ([v1, v2]) => {
        if (v1 && v2) {
          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.windowSizePreset,
              preset: v1
            }
          });
        }
      },
      { immediate: true }
    );

    const isHangupRequestVisible = ref(false);

    const localVideoRef = ref(),
      localVideoPreviewRef = ref();
    const remoteVideoRef = ref();
    const remoteAudioRef = ref();

    const remoteShareVideoRef = ref();

    const localVideoContainerRef = ref();
    const remoteVideoContainerRef = ref();
    const remoteAudioContainerRef = ref();

    const isHangupButtonEnabled = computed((): boolean =>
      telephonyType.value === TelephonyType.webex
        ? !(
            endpointStatusCode.value === EndpointStatus.ready &&
            getRouteQueryValue("topic")
          )
        : true
    );

    const documentInputKey = ref(0);

    const handleDocumentInputChange = (e: Event) => {
      const files: FileList = _.get(e.target, "files");
      if (!files.length) {
        return;
      }

      const file = files[0];

      if (!_.startsWith(file.type, "image/") && file.size > 5 * 1024 * 1024) {
        showToastError(i18n.global.t("call.error.documentSize"));
        documentInputKey.value++;
        return;
      }

      store.dispatch("sharing/shareDocument", {
        file,
        callback: (data: unknown) => {
          showToastSuccess(i18n.global.t("call.success.document"));
          documentInputKey.value++;
        },
        errorCallback: (err: unknown) => {
          showToastError(i18n.global.t("call.error.document"));
          documentInputKey.value++;
        }
      });
    };

    watch(
      () => [
        _.assign(
          {},
          store.state.auth.profile?.properties ?? {},
          store.state.auth.extraProperties ?? {}
        ),
        endpointStatusCode.value === EndpointStatus.connected &&
          store.state.network.status === "connected"
      ],
      ([v1, v2]) => {
        if (_.keys(v1).length && v2) {
          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.properties,
              properties: v1
            }
          });
        }
      },
      { immediate: true, deep: true }
    );

    const isVideoOn = computed(() => store.getters.isVideoOn),
      isCameraEnabled = computed(
        () => store.state.session.mediaDevices.isCameraEnabled
      );

    watch(
      () => isCameraEnabled.value,
      v =>
        sendParentWindowMessage({
          type: v ? "cameraEnabled" : "cameraDisabled"
        }),
      { immediate: true }
    );

    const isMicModeButtonEnabled = ref(true);

    const isMicrophoneEnabled = computed(
      () => store.state.session.mediaDevices.isMicrophoneEnabled
    );

    watch(
      () => isMicrophoneEnabled.value,
      v =>
        sendParentWindowMessage({
          type: v ? "microphoneEnabled" : "microphoneDisabled"
        }),
      { immediate: true }
    );

    const switchMicrophoneMode = async () => {
      isMicModeButtonEnabled.value = false;
      await store
        .dispatch(
          `session/mediaDevices/${
            isMicrophoneEnabled.value ? "disableMicrophone" : "enableMicrophone"
          }`
        )
        .finally(() => (isMicModeButtonEnabled.value = true));
    };

    const refreshMediaInputs = async () => {
      await store.dispatch("session/mediaDevices/getCameras");
      await store.dispatch("session/mediaDevices/getMicrophones");
    };

    const cameras = computed<
        {
          camera: MediaDeviceInfo;
          isActive: boolean;
        }[]
      >(() => {
        let cameras = store.state.session.mediaDevices.cameras ?? [];

        cameras =
          cameras.length > 2 &&
          // for some reason iPhone cameras list can include not only 1 back and 1 front ones
          getUaParserResult()?.os?.name === OSName.IOS
            ? _.slice(cameras, 0, 2)
            : cameras;

        if (!cameras.length || _.find(cameras, c => !!c.isActive)) {
          return cameras;
        }
        if (cameras.length === 1) {
          return _.map(cameras, c => _.assign({}, c, { isActive: true }));
        }
        return cameras;
      }),
      microphones = computed<
        {
          microphone: MediaDeviceInfo;
          isActive: boolean;
        }[]
      >(() => store.state.session.mediaDevices.microphones ?? []);

    const cameraId = ref<string | null>(null),
      microphoneId = ref<string | null>(null);

    const getNextCameraId = async (deviceId?: string) => {
      if (cameras.value?.length < 2) {
        return null;
      }

      if (
        !_.find(cameras.value, c =>
          deviceId ? c.camera.deviceId === deviceId : c.isActive
        )
      ) {
        await refreshMediaInputs();
      }

      const index = _.findIndex(cameras.value, c =>
        deviceId ? c.camera.deviceId === deviceId : c.isActive
      );

      return index === cameras.value?.length - 1
        ? _.first(cameras.value)!.camera.deviceId
        : cameras.value[index + 1]!.camera.deviceId;
    };

    const getMicrophoneId = () =>
      _.find(microphones.value, m => m.isActive)?.microphone.deviceId ?? null;

    const getCameraType = (deviceId: string) => {
        if (
          !_.includes([DeviceType.mobile, DeviceType.tablet], getDeviceType())
        ) {
          return null;
        }

        if (
          deviceId &&
          telephonyType.value === TelephonyType.webrtc &&
          store.state.webrtc.streams.local instanceof MediaStream
        ) {
          const track = _.find(
            (store.state.webrtc.streams.local as MediaStream)?.getVideoTracks(),
            t =>
              t?.getSettings()?.deviceId === deviceId &&
              _.includes(["user", "environment"], t?.getSettings()?.facingMode)
          );

          if (track) {
            return track.getSettings()?.facingMode === "environment"
              ? "back"
              : "front";
          }
        }

        const camera = _.find(
          cameras.value,
          c => c?.camera?.deviceId === deviceId
        );

        if (_.includes(_.toLower(camera?.camera?.label), "front")) {
          return "front";
        } else if (_.includes(_.toLower(camera?.camera?.label), "back")) {
          return "back";
        }

        return cameras.value?.length === 2
          ? _.first(cameras.value)?.camera.deviceId === deviceId
            ? "front"
            : "back"
          : null;
      },
      activeCameraType = ref<"front" | "back" | null>(
        cameraId.value ? getCameraType(cameraId.value) : null
      ),
      isLocalVideoFullscreen = ref<boolean>();

    const switchMicrophone = async (deviceId: string) => {
      await store.dispatch("session/mediaDevices/switchMicrophone", deviceId);
      await refreshMediaInputs();
    };

    const switchCamera = async (deviceId: string) => {
      let tries = 0;

      let id: string | null = deviceId;

      const handle = async () => {
        tries++;
        try {
          await store.dispatch("session/mediaDevices/switchCamera", id);
        } catch (err) {
          console.error("Camera switching error: ", err);
          if (tries < cameras.value.length) {
            id = await getNextCameraId(id!);

            if (!id) {
              console.error("Can not find next camera");
            }
            console.log(`Alternatively switching to "${id}" camera...`);
            await handle();
          }
        }
      };

      await handle();

      await refreshMediaInputs();

      activeCameraType.value = getCameraType(deviceId);
      isLocalVideoFullscreen.value = activeCameraType.value === "back";
    };

    watch(
      () => cameraId.value,
      val => {
        if (
          val &&
          _.find(cameras.value, c => c.isActive)?.camera.deviceId !== val
        ) {
          // camera changed manually
          switchCamera(val);
        }
      }
    );

    watch(
      () => microphoneId.value,
      val => {
        if (val && getMicrophoneId() !== val) {
          // microphone changed manually
          switchMicrophone(val);
        }
      }
    );

    watch(
      () => cameras.value,
      v => {
        cameraId.value = _.find(v, c => c.isActive)?.camera.deviceId ?? null;
        sendParentWindowMessage({ type: "cameraListChanged", cameras: v });
      },
      { immediate: true }
    );

    watch(
      () => microphones.value,
      v => {
        microphoneId.value = getMicrophoneId();
        sendParentWindowMessage({
          type: "microphoneListChanged",
          microphones: v
        });
      },
      { immediate: true }
    );

    const isEmbedded = ref(false);

    const closeWindow = () =>
        _.get(window, "closeREclientWindowAfterSession", false)
          ? // app opened in new tab
            window.close()
          : // app opened in iframe
            sendParentWindowMessage({ type: "close" }),
      closeWindowWithDelay = () =>
        window.setTimeout(() => closeWindow(), 10000);

    const hangup = async () => {
      isHangupRequestVisible.value = false;

      if (
        +endpointStatusCode.value === EndpointStatus.unknown &&
        getRouteQueryValue("topic")
      ) {
        await unsetRouteQueryKey("topic");
        context.emit("toTopics");

        return;
      }

      return new Promise((resolve, reject) =>
        store.dispatch("queue/release", {
          callback: () => {
            context.emit("hangup");
            resolve();
          },
          errorCallback: reject
        })
      );
    };

    listenParentWindowMessages({
      resized: (data: { preset: WindowSizePreset }) =>
        (windowSizePreset.value = data.preset),
      urlChanged: (data: { url: string }) => {
        isEmbedded.value = true;

        if (endpointStatusCode.value === EndpointStatus.connected) {
          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.parentWindowUrl,
              url: data.url
            }
          });
        }
      },
      hangup: async () => await hangup(),
      enableCamera: async () =>
        await store.dispatch("session/mediaDevices/enableCamera"),
      disableCamera: async () =>
        await store.dispatch("session/mediaDevices/disableCamera"),
      switchCamera: async (deviceId: string) => await switchCamera(deviceId),
      enableMicrophone: async () => await switchMicrophoneMode(),
      disableMicrophone: async () => await switchMicrophoneMode(),
      switchMicrophone: async (deviceId: string) =>
        await switchMicrophone(deviceId)
    });

    sendParentWindowMessage({ type: "getWindowUrl" });
    sendParentWindowMessage({ type: "getSize" });

    const setTestLocalAndRemoteVideos = (): void => {
      remoteVideoRef.value.src = "/staging/videos/remote.webm";
      localVideoRef.value.src = "/staging/videos/local.webm";
      localVideoPreviewRef.value.src = "/staging/videos/local.webm";
    };

    const setTestSharedScreenVideo = (): void => {
      remoteVideoRef.value.src = "/staging/videos/screen.mp4";
    };

    const setTestRemoteViewConfig = () =>
      store.commit("session/SET_REMOTE_VIEW_CONFIG", {
        type: RobotType.animatedCharacter,
        background: `${config.value.publicPath ??
          "/"}staging/img/remote-video-background.jpg`,
        // eslint-disable-next-line @typescript-eslint/camelcase
        animated_character: {
          avatar: {
            character: "female-3",
            clothes: "casual-1",
            hair: {
              color: "#191919",
              style: 34
            },
            glasses: 2,
            logo: `${config.value.publicPath ??
              "/"}staging/img/animated-character-avatar-logo.png`
          },
          // eslint-disable-next-line @typescript-eslint/camelcase
          camera_view: "upper"
        }
      } as RemoteViewConfigDto);

    const remoteViewConfig = computed(
        (): RemoteViewConfigDto | null => store.state.session.remoteViewConfig
      ),
      remoteViewCustomBackground = computed(
        (): RemoteViewCustomBackground | null =>
          store.state.session.remoteViewCustomBackground
      );

    watch(
      () => remoteViewConfig.value,
      v => {
        const avatar = v?.animated_character?.avatar;

        if (avatar && "model" in avatar) {
          preloadAvatarGlb(avatar?.model);
        }
      },
      { immediate: true }
    );

    const acquireFailedRequestReason = computed(
      (): AcquireFailedRequestReason | null =>
        store.state.queue.acquireFailedRequestReason
    );

    const appType = computed(() => store.state.auth.profile?.app?.type);

    const isKioskType = computed(() => store.getters["auth/isKioskType"]),
      isKioskPortrait = computed(
        () => isKioskType.value && appType.value === ClientAppType.kioskPortrait
      );

    const isInteractiveSharingEnabled = computed(
        () => store.state.sharing.remote.isInteractive && isKioskOs.value
      ),
      remoteShareVideoStream = computed(() =>
        isInteractiveSharingEnabled.value
          ? null
          : store.state.sharing.remote.stream ?? null
      );

    watchEffect(() => {
      if (remoteVideoRef.value) {
        if (
          store.state.sharing.remote.file?.url &&
          ["video/mp4"].includes(store.state.sharing.remote.file?.mimeType)
        ) {
          remoteVideoRef.value.srcObject = null;
          remoteVideoRef.value.src = store.state.sharing.remote.file.url;
        } else {
          if (remoteVideoRef.value.src) {
            remoteVideoRef.value.src = null;
          }
          remoteVideoRef.value.srcObject =
            (isKioskPortrait.value ? null : remoteShareVideoStream.value) ??
            (telephonyType.value === TelephonyType.webex
              ? store.state.webex.streams.remoteVideo
              : telephonyType.value === TelephonyType.webrtc
              ? store.state.webrtc.streams.remote
              : null) ??
            null;
        }
      }

      const localVideoStream =
        (telephonyType.value === TelephonyType.webex
          ? store.state.webex.streams.localVideo?.outputStream
          : telephonyType.value === TelephonyType.webrtc
          ? store.state.webrtc.streams.local instanceof MediaStream
            ? store.state.webrtc.streams.local
            : null
          : null) ?? null;

      if (localVideoRef.value) {
        localVideoRef.value.srcObject = localVideoStream;
      }
      if (localVideoPreviewRef.value) {
        localVideoPreviewRef.value.srcObject = localVideoStream;
      }
      if (remoteAudioRef.value) {
        remoteAudioRef.value.srcObject =
          (telephonyType.value === TelephonyType.webex
            ? store.state.webex.streams.remoteAudio
            : null) ??
          (telephonyType.value === TelephonyType.webrtc &&
          !!remoteShareVideoStream.value &&
          !isKioskPortrait.value
            ? store.state.webrtc.streams.remote
            : null) ??
          null;
      }

      if (remoteShareVideoRef.value) {
        remoteShareVideoRef.value.srcObject = remoteShareVideoStream.value;
      }
    });

    const sendPeerData = (data: {}) => {
      console.log("Sending data to peer...", data);
      store.state.sharing.remote.peer?.send(JSON.stringify(data));
    };

    const windowHeight = ref<number>();
    const windowWidth = ref<number>();

    const windowAspectRatio = computed(() =>
      windowHeight.value && windowWidth.value
        ? windowWidth.value / windowHeight.value
        : null
    );

    const remoteVideoAspectRatio = ref<number>();

    const touchEvents = ref<any[]>([]);

    const handleKeyUpDown = (e: KeyboardEvent) => {
      const ignoredButtons = ["CapsLock"];

      if (ignoredButtons.includes(e.key)) {
        return;
      }

      e.preventDefault();

      const serviceButtons = {
        "{backspace}": "Backspace",
        "{tab}": "Tab",
        "{enter}": "Enter",
        "{escape}": "Escape",
        "{insert}": "Insert",
        "{delete}": "Delete",
        "{home}": "Home",
        "{end}": "End",
        "{pageup}": "PageUp",
        "{pagedown}": "PageDown",
        "{arrowleft}": "ArrowLeft",
        "{arrowup}": "ArrowUp",
        "{arrowright}": "ArrowRight",
        "{arrowdown}": "ArrowDown",
        "{f1}": "F1",
        "{f2}": "F2",
        "{f3}": "F3",
        "{f4}": "F4",
        "{f5}": "F5",
        "{f6}": "F6",
        "{f7}": "F7",
        "{f8}": "F8",
        "{f9}": "F9",
        "{f10}": "F10",
        "{f11}": "F11",
        "{f12}": "F12",
        "{shift}": "Shift",
        "{control}": "Control",
        // "{windows}": , no code and event
        "{alt}": "Alt",
        "{menu}": "ContextMenu"
        // "{capslock}": 'CapsLock' ignored
      };

      sendPeerData({
        type: "key",
        down: e.type === "keydown",
        key: _.findKey(serviceButtons, v => v === e.key) ?? e.key
      });

      return false;
    };

    watchEffect(() => {
      if (!isKioskOs.value) {
        return;
      }
      if (isInteractiveSharingEnabled.value) {
        document.addEventListener("keydown", handleKeyUpDown);
        document.addEventListener("keyup", handleKeyUpDown);
      } else {
        document.removeEventListener("keydown", handleKeyUpDown);
        document.removeEventListener("keyup", handleKeyUpDown);
      }
    });

    const mobileKeyboardInputValue = ref<string>("_".repeat(10000));
    const isMobileKeyboardEnabled = ref(false);
    const inputKey = ref(0);

    watchEffect(() => {
      if (!isMobileKeyboardEnabled.value) {
        mobileKeyboardInputValue.value = "_".repeat(10000);
        inputKey.value++;
        touchEvents.value = [];
      }
    });

    const handleMobileKeyboardInput = (e: InputEvent) =>
      [true, false].forEach(isDown =>
        sendPeerData({
          type: "key",
          down: isDown,
          key: e.data
            ? e.data.slice(-1)
            : e.inputType === "deleteContentBackward"
            ? "{backspace}"
            : "{enter}"
        })
      );

    const handleWindowResize = (e: Event) => {
      const target = e.target! as Window;
      windowHeight.value = target.innerHeight;
      windowWidth.value = target.innerWidth;
    };

    onMounted(() => {
      windowHeight.value = window.innerHeight;
      windowWidth.value = window.innerWidth;
      window.addEventListener("resize", handleWindowResize);
    });

    onUnmounted(() => window.removeEventListener("resize", handleWindowResize));

    const remoteVideoContainerStyleObject = computed(() => {
      if (
        _.includes([DeviceType.mobile, DeviceType.tablet], getDeviceType()) ||
        !_.includes(
          [BrowserName.FIREFOX, BrowserName.FIREFOX_MOBILE],
          getUaParserResult()?.browser?.name
        ) ||
        (aspectRatio.value === AspectRatioMode.cover &&
          !(remoteShareVideoStream.value && !isKioskPortrait.value) &&
          store.state.sharing.remote.file?.mimeType !== "video/mp4") ||
        !(windowAspectRatio.value && remoteVideoAspectRatio.value)
      ) {
        return {
          /*empty*/
        };
      }

      return windowAspectRatio.value > remoteVideoAspectRatio.value
        ? {
            width: `${(remoteVideoAspectRatio.value * 100) /
              windowAspectRatio.value}%`,
            height: "100%",
            left: "50%",
            transform: "translate(-50%, 0)"
          }
        : {
            width: "100%",
            height: `${(windowAspectRatio.value * 100) /
              remoteVideoAspectRatio.value}%`,
            top: "50%",
            transform: "translate(0, -50%)"
          };
    });

    watch(
      () => [
        microphones.value,
        endpointStatusCode.value === EndpointStatus.connected &&
          store.state.network.status === "connected"
      ],
      ([v1, v2]) => {
        if (v1 && v2) {
          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.microphones,
              data: v1
            }
          });
        }
      }
    );

    const isMediaInputSettingsAvailable = computed(
      () =>
        !isWindowMinimized.value &&
        (endpointStatusCode.value === EndpointStatus.connected ||
          (telephonyType.value === TelephonyType.webex
            ? (queuePosition.value >= 0 ||
                endpointStatusCode.value === EndpointStatus.placingCall) &&
              ![EndpointStatus.unknown, EndpointStatus.failure].includes(
                +endpointStatusCode.value
              )
            : false))
    );

    watch(
      () => isMediaInputSettingsAvailable.value,
      async v => {
        if (v) {
          await refreshMediaInputs();
        }
      },
      { immediate: true }
    );

    const isSettingsModalVisible = ref(false),
      isSettingsButtonVisible = computed(
        () => !isKioskType.value && isMediaInputSettingsAvailable.value
      );

    watch(
      () => isSettingsModalVisible.value,
      v => {
        if (!v) {
          isSettingsModalVisible.value = false;
        }
      }
    );

    const documentInputRef = ref();

    const requestedRemoteActions = computed(
      (): { action: RequestedAction; payload?: any }[] | null =>
        store.state.session.requestedActions
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.sendCallInviteLink
        ) && !!sharedLink.value,
      v => {
        if (v) {
          store.dispatch("session/sendTextHint", {
            data: {
              text: sharedLink.value
            }
          });
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.sendCallInviteLink
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideQrCode
        ),
      v => {
        if (v) {
          store.commit("session/UNSET_QR_CODE");
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.hideQrCode
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideTextHint
        ),
      v => {
        if (v) {
          store.commit("session/UNSET_TEXT_HINT");
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.hideTextHint
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideTranslation
        ),
      v => {
        if (v) {
          store.commit("session/UNSET_RECORD_TRANSLATION");
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.hideTranslation
          );
        }
      }
    );

    const fullscreenImage = computed(
      (): { image: string; aspectRatio?: "cover" | "contain" } | null =>
        store.state.session.fullscreenImage
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideFullscreenImage
        ),
      v => {
        if (v) {
          store.commit("session/UNSET_FULLSCREEN_IMAGE");
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.hideFullscreenImage
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideFileRequest
        ),
      v => {
        if (v) {
          _.forEach(
            [RequestedAction.hideFileRequest, RequestedAction.showFileRequest],
            a => store.commit("session/UNSET_REQUESTED_ACTION", a)
          );
        }
      }
    );

    const handleRemoteActionRequestReject = (action: RequestedAction) =>
      store.commit("session/UNSET_REQUESTED_ACTION", action);

    const handleRemoteActionRequestApprove = async (
      action: RequestedAction
    ) => {
      if (action === RequestedAction.showFileRequest) {
        documentInputRef.value?.click();
      } else if (action === RequestedAction.startScreenSharing) {
        store.dispatch("sharing/shareStream", {
          type: "screen",
          errorCallback: (err: unknown) =>
            showToastError("Can not share desktop")
        });
      }
      store.commit("session/UNSET_REQUESTED_ACTION", action);
    };

    watch(
      () =>
        _.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.videoChatNextCamera
        ),
      async v => {
        if (v) {
          const deviceId = await (async () => {
            const mode = (v.payload as Pick<
                MediaTrackConstraintSet,
                "facingMode"
              >)?.facingMode,
              type = mode
                ? _.get(
                    {
                      user: "front",
                      environment: "back"
                    },
                    mode as string,
                    null
                  )
                : null;

            if (!type || getDeviceType() !== DeviceType.mobile) {
              return await getNextCameraId();
            }

            let camera = _.find(
              cameras.value,
              c => getCameraType(c.camera?.deviceId) === type
            );
            if (!camera) {
              await refreshMediaInputs();
            }

            camera = _.find(
              cameras.value,
              c => getCameraType(c.camera?.deviceId) === type
            );

            return camera?.camera?.deviceId
              ? cameraId.value === camera?.camera?.deviceId
                ? null
                : camera?.camera?.deviceId
              : await getNextCameraId();
          })();

          if (deviceId) {
            await switchCamera(deviceId);
          }
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.videoChatNextCamera
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.videoChatEnableCamera
        ),
      async v => {
        if (v) {
          await store.dispatch("session/mediaDevices/enableCamera");
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.videoChatEnableCamera
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.videoChatDisableCamera
        ),
      async v => {
        if (v) {
          await store.dispatch("session/mediaDevices/disableCamera");
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.videoChatDisableCamera
          );
        }
      }
    );

    watch(
      () =>
        _.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.videoChatSetMicrophone
        ),
      async v => {
        if (v) {
          if (microphones.value?.length > 1) {
            await switchMicrophone(v.payload as string);
          }
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.videoChatSetMicrophone
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.changeAspectRatio
        ),
      async v => {
        if (v) {
          aspectRatio.value =
            aspectRatio.value === AspectRatioMode.contain
              ? AspectRatioMode.cover
              : AspectRatioMode.contain;
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.changeAspectRatio
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.stopScreenSharing
        ),
      async v => {
        if (v) {
          if (store.state.sharing.local.stream) {
            store.dispatch("sharing/stopStreamSharing");
          }

          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.stopScreenSharing
          );
        }
      }
    );

    const isSelfViewVisible = ref(!!config.value.isSelfViewVisible);

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.showSelfView
        ),
      async v => {
        if (v) {
          isSelfViewVisible.value = true;

          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.showSelfView
          );
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideSelfView
        ),
      async v => {
        if (v) {
          isSelfViewVisible.value = false;

          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.hideSelfView
          );
        }
      }
    );

    const compressCanvas = async (
      canvas: HTMLCanvasElement
    ): Promise<HTMLImageElement> => {
      let resolve: Function, reject: Function;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });

      canvas.toBlob(
        async blob => {
          const options = {
            maxSizeMB: 0.3,
            maxWidthOrHeight: 1000,
            useWebWorker: true
          };

          const file = await imageCompression(
            new File([blob!], "Image.jpeg", {
              type: blob!.type
            }),
            options
          );

          const fr = new FileReader();

          fr.onload = () => {
            const img = new Image();

            img.onload = () => resolve(img);

            img.src = `${fr.result}`;
          };

          fr.readAsDataURL(file);
        },
        "image/jpeg",
        1
      );

      return promise as Promise<HTMLImageElement>;
    };

    const takeCameraSnapshot = async () => {
      const cb = async (obj: HTMLVideoElement | ImageBitmap) => {
          const canvas = document.createElement("canvas");
          canvas.width =
            obj instanceof HTMLVideoElement ? obj.videoWidth : obj.width;
          canvas.height =
            obj instanceof HTMLVideoElement ? obj.videoHeight : obj.height;
          const ctx = canvas.getContext("2d");
          ctx!.drawImage(obj, 0, 0);

          const img = await compressCanvas(canvas);

          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.cameraSnapshot,
              url: img.src,
              width: img.width,
              height: img.height
            }
          });
        },
        errCb = (err: Error | string) => {
          err instanceof Error
            ? console.error("Take a camera snapshot error: ", err)
            : console.error(err);

          showToastError(i18n.global.t("call.error.cameraSnapshot"));

          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.cameraSnapshot,
              error: err instanceof Error ? err.message : err
            }
          });
        };

      if (
        [TelephonyType.webex, TelephonyType.webrtc].includes(
          telephonyType.value
        ) &&
        typeof ImageCapture === "function" &&
        getUaParserResult()?.os?.name !== OSName.IOS
      ) {
        const track = (telephonyType.value === TelephonyType.webex
          ? store.state.webex.streams.localVideo?.outputStream
          : store.state.webrtc.streams.local
        )?.getVideoTracks?.()?.[0];

        if (!track) {
          errCb("Can not take a camera snapshot, no video track");
          return;
        }

        const imageCapture = new ImageCapture(track);

        imageCapture
          .grabFrame()
          .then((bitmap: ImageBitmap) => cb(bitmap))
          .catch((err: Error) => errCb(err));
      } else {
        const videoHtml = [TelephonyType.webex, TelephonyType.webrtc].includes(
          telephonyType.value
        )
          ? localVideoRef.value
          : (store.state.twilio.media.local as HTMLVideoElement);

        cb(videoHtml);
      }
    };

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.cameraSnapshot
        ),
      async v => {
        if (v) {
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.cameraSnapshot
          );

          await takeCameraSnapshot();
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.screenshot
        ),
      async v => {
        if (v) {
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.screenshot
          );

          const img = await compressCanvas(await html2canvas(document.body));

          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.screenshot,
              screenshot: img.src
            }
          });
        }
      }
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.getPrinterStates
        ),
      async v => {
        if (v) {
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.getPrinterStates
          );

          store.dispatch("printer/getStates", {
            callback: (states: Record<string, number>) =>
              store.dispatch("session/sendJsonMessage", {
                message: {
                  type: MessageType.printerStates,
                  states
                }
              }),
            errorCallback: (err?: Error | string) =>
              store.dispatch("session/sendJsonMessage", {
                message: {
                  type: MessageType.printerStates,
                  error: _.isString(err)
                    ? err
                    : err instanceof Error
                    ? err.message
                    : "Can not get printer states"
                }
              })
          });
        }
      },
      { immediate: true }
    );

    watch(
      () =>
        _.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.print
        ),
      async v => {
        if (v) {
          store.commit("session/UNSET_REQUESTED_ACTION", RequestedAction.print);

          const { printer_name: printer, pdf_data: pdf } = v.payload as Record<
            "printer_name" | "pdf_data",
            string
          >;

          store.dispatch("printer/print", {
            printer,
            pdf,
            callback: (result: boolean) =>
              store.dispatch("session/sendJsonMessage", {
                message: {
                  type: MessageType.printStatus,
                  successful: result
                }
              })
          });
        }
      },
      { immediate: true }
    );

    watch(
      () => endpointStatusCode.value === EndpointStatus.connected,
      v => {
        if (v) {
          aspectRatio.value =
            config.value.remoteVideoAspectRatioMode === "contain"
              ? AspectRatioMode.contain
              : AspectRatioMode.cover;
        } else {
          aspectRatio.value = AspectRatioMode.contain;
          isSelfViewVisible.value = !!config.value.isSelfViewVisible;
        }
      },
      { immediate: true }
    );

    const isFeedbackCreating = ref(false);
    const handleFeedbackClick = async (rate: number) => {
      isFeedbackCreating.value = true;

      try {
        await store.dispatch("session/createFeedback", {
          // eslint-disable-next-line @typescript-eslint/camelcase
          session_id: JSON.parse(
            (route.query.feedback_payload ?? "{}") as string
          )?.session?.id,
          rate
        });
      } catch (err) {
        showFailedRequestToastError(err);
        isFeedbackCreating.value = false;
        return;
      }

      isFeedbackCreating.value = false;

      showToastSuccess(i18n.global.t("call.success.feedback"));

      context.emit("toTopics");
    };

    const isOnHold = computed(() => store.getters.isOnHold);

    watch(
      () => isOnHold.value,
      v => {
        if (v) {
          store.commit("session/UNSET_VISUAL_HINT");
          store.commit("session/UNSET_QR_CODE");
          store.commit("session/UNSET_TEXT_HINT");
        }
      },
      { immediate: true }
    );

    const isSharedFileModalVisible = ref(false);
    const sharedFile = computed(() => store.state.sharing.remote.file);

    const sharedFileLink = ref<string>();
    const isSafari = _.includes(
      [BrowserName.SAFARI, BrowserName.SAFARI_MOBILE],
      getUaParserResult()?.browser?.name
    );

    const generateBlobLink = (b64: string, mimeType: string) => {
      const binaryString = window.atob(b64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const b64ArrayBuffer = bytes.buffer;
      const blob = new Blob([b64ArrayBuffer], { type: mimeType });
      return URL.createObjectURL(blob);
    };

    watch(
      () => sharedFile.value,
      v => {
        if (!v) {
          return;
        }

        if (
          sharedFileLink.value &&
          _.startsWith(sharedFileLink.value, "blob:")
        ) {
          URL.revokeObjectURL(sharedFileLink.value!);
        }
        sharedFileLink.value = isSafari
          ? generateBlobLink(v.data, v.mimeType)
          : `data:${v.mimeType};base64,${v.data}`;
        isSharedFileModalVisible.value = true;
      }
    );

    watch(
      () => [
        localVideoContainerRef.value,
        store.state.twilio.media.local || store.state.zoom.video.local
      ],
      ([v1, v2]) => {
        if (!v1) {
          return;
        }

        localVideoContainerRef.value.innerHTML = "";

        if (v2) {
          localVideoContainerRef.value?.appendChild(v2);
        }
      }
    );

    watch(
      () => [
        remoteVideoContainerRef.value,
        store.state.twilio.media.remote ||
          _.first(_.values(store.state.zoom.video.remote)),
        telephonyType.value === TelephonyType.zoom ? aspectRatio.value : null
      ],
      ([v1, v2, v3]) => {
        if (!v1) {
          return;
        }

        remoteVideoContainerRef.value.innerHTML = "";

        if (telephonyType.value === TelephonyType.twilio) {
          remoteAudioContainerRef.value.innerHTML = "";

          if (v2) {
            v2.forEach((m: HTMLMediaElement) => {
              (m instanceof HTMLVideoElement
                ? remoteVideoContainerRef
                : remoteAudioContainerRef
              ).value.appendChild(m);
            });
          }
        } else if (telephonyType.value === TelephonyType.zoom && v2) {
          const className = "remote-video-container--cover";
          remoteVideoContainerRef.value.classList.remove(className);

          if (v3 === AspectRatioMode.cover) {
            remoteVideoContainerRef.value.classList.add(className);
          }

          remoteVideoContainerRef.value.appendChild(v2);
        }
      }
    );

    enum Screen {
      calling,
      onCall,
      endCall,
      transferring,
      failure
    }

    const activeScreen = computed((): Screen | null => {
      if (route.name === "thank") {
        return Screen.endCall;
      } else if (
        errorMessage.value ||
        endpointStatusCode.value === EndpointStatus.failure ||
        isThrownFromQueueUrgently.value ||
        (+queuePosition.value &&
          _.includes(
            [
              CallQueuePositionChangedReason.noTopic,
              CallQueuePositionChangedReason.timeout,
              CallQueuePositionChangedReason.noExperts
            ],
            store.state.queue.positionChangeReason
          ))
      ) {
        return Screen.failure;
      } else if (
        getRouteQueryValue("topic") ||
        getRouteQueryValue("room_id") ||
        endpointStatusCode.value === EndpointStatus.placingCall ||
        (queuePosition.value !== null && queuePosition.value >= 0) ||
        (config.value?.envMode !== "staging" &&
          endpointStatusCode.value === EndpointStatus.connected &&
          (!sessionInfo.value ||
            sessionInfo.value?.client_type === AuthenticatableType.robot) &&
          !_.find(
            requestedRemoteActions.value,
            v => v.action === RequestedAction.showRobotCallScreen
          ))
      ) {
        return Screen.calling;
      } else if (endpointStatusCode.value === EndpointStatus.connected) {
        return Screen.onCall;
      } else if (endpointStatusCode.value === EndpointStatus.transferring) {
        return Screen.transferring;
      }

      return null;
    });

    const isLowPerformanceAndroid =
        _.includes([DeviceType.mobile, DeviceType.tablet], getDeviceType()) &&
        getUaParserResult()?.os?.name === OSName.ANDROID &&
        _.get(navigator, "deviceMemory", 2) <= 2,
      isLowPerformanceModalVisible = ref(false);

    const animatedCharacterState = ref<string | null>(null);

    watchEffect(() => {
      if (activeScreen.value === Screen.onCall) {
        isHangupRequestVisible.value = false;
        isOpenUrlRequestVisible.value = false;
        isLowPerformanceModalVisible.value = false;
      } else {
        isLowPerformanceModalVisible.value = isLowPerformanceAndroid;
        animatedCharacterState.value = null;
      }
    });

    const stopArecorderSession = () =>
      store.dispatch("arecorder/stopSession", {
        errorCallback: () => showToastError("Can not stop arecorder session")
      });

    watch(
      () => activeScreen.value === Screen.onCall,
      async v => {
        if (!isKioskOs.value) {
          return;
        }

        if (v) {
          store.dispatch("arecorder/startSession", {
            errorCallback: () =>
              showToastError("Can not start arecorder session")
          });
        } else {
          stopArecorderSession();
        }
      },
      { immediate: true }
    );

    onBeforeUnmount(() => {
      if (isKioskOs.value) {
        stopArecorderSession();
      }
    });

    const primaryMessage = computed((): string | null => {
        if (activeScreen.value === Screen.calling) {
          if (
            getRouteQueryValue("room_id") &&
            store.state.session.room === null
          ) {
            return null;
          }

          return store.state.session.room?.id
            ? "Reconnecting..."
            : i18n.global.t("call.calling");
        } else if (activeScreen.value === Screen.failure) {
          if (errorMessage.value) {
            return errorMessage.value;
          }
          if (endpointStatusCode.value === EndpointStatus.failure) {
            return _.includes(
              [
                EndpointStatusDetails.disabledSafariMediaInputsAccess,
                EndpointStatusDetails.mediaStreamsCreatingError
              ],
              store.state.endpointStatus?.details
            )
              ? i18n.global.t("call.error.mediaInputsAccess")
              : i18n.global.t("call.error.base");
          }

          const noExpertsText = config.value.noExpertsText?.[appLocale.value]
            ? decodeURI(config.value.noExpertsText?.[appLocale.value])
            : i18n.global.t("call.error.noExperts");

          if (acquireFailedRequestReason.value !== null) {
            return (
              {
                [AcquireFailedRequestReason.noExperts]: noExpertsText,
                [AcquireFailedRequestReason.noExpertsForLang]: noExpertsText,
                [AcquireFailedRequestReason.queueSuspended]: i18n.global.t(
                  "call.error.queueSuspended"
                ),
                [AcquireFailedRequestReason.queueOverloaded]: i18n.global.t(
                  "call.error.queueOverloaded"
                )
              }[acquireFailedRequestReason.value] ?? null
            );
          }

          if (+queuePosition.value) {
            if (
              store.state.queue.positionChangeReason ===
              CallQueuePositionChangedReason.noTopic
            ) {
              return i18n.global.t("call.error.noTopic");
            }
            if (
              store.state.queue.positionChangeReason ===
              CallQueuePositionChangedReason.timeout
            ) {
              return i18n.global.t("call.error.timeout");
            }
            if (
              store.state.queue.positionChangeReason ===
              CallQueuePositionChangedReason.noExperts
            ) {
              return noExpertsText;
            }
          }
        } else if (activeScreen.value === Screen.endCall) {
          return config.value.thankPageTitleText?.[appLocale.value]
            ? decodeURI(config.value.thankPageTitleText?.[appLocale.value])
            : null;
        } else if (activeScreen.value === Screen.transferring) {
          return i18n.global.t("call.transferring");
        }
        return null;
      }),
      secondaryMessage = computed((): string | null => {
        if (activeScreen.value !== Screen.calling) {
          return null;
        }

        if (
          getRouteQueryValue("room_id") &&
          (store.state.session.room === null || store.state.session.room?.id)
        ) {
          return null;
        }

        return queuePosition.value !== null &&
          queuePosition.value >= 0 &&
          store.state.hints !== null
          ? i18n.global.t("call.queuePosition", [
              _.max([+queuePosition.value + 1, 1]),
              !!(store.state.hints & 0x1)
            ])
          : null;
      });

    watch(
      () => activeScreen.value === Screen.failure,
      async v => {
        if (
          v &&
          [TelephonyType.webex, TelephonyType.webrtc].includes(
            telephonyType.value
          )
        ) {
          deleteLocalMediaStreams();
          if (getRouteQueryValue("topic")) {
            await unsetRouteQueryKey("topic");
          }
        }
      },
      { immediate: true }
    );

    const isFeedbackFormEnabled = computed(
        () => !!(config.value?.feedbackEnabled && !isKioskType.value) && false
      ),
      isFeedbackFormVisible = ref(false);

    const timestamp = useTimestamp({ interval: 500 }),
      { lastActive } = useIdle();

    const idleTimerScreens = computed(() =>
      _.concat(
        isEmbedded.value ? [] : Screen.endCall,
        isKioskOs.value || isWebKiosk.value ? Screen.failure : []
      )
    );

    onMounted(() => {
      watch(
        () => timestamp.value,
        v => {
          if (!_.includes(idleTimerScreens.value, activeScreen.value)) {
            // workaround to apply idle timer only for needed screens
            lastActive.value = +moment();
          }
        },
        { immediate: true }
      );

      watch(
        () =>
          _.includes(idleTimerScreens.value, activeScreen.value) &&
          timestamp.value - lastActive.value >=
            (activeScreen.value === Screen.endCall &&
            isFeedbackFormVisible.value
              ? 1.5 * 60 * 1000
              : 10 * 1000),
        v => {
          if (v) {
            context.emit("idle");
          }
        },
        { immediate: true }
      );
    });

    watch(
      [
        () =>
          endpointStatusCode.value === EndpointStatus.connected &&
          store.state.network.status === "connected",
        () => aspectRatio.value
      ],
      ([v1, v2]) => {
        if (v1) {
          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.aspectRatio,
              aspectRatio: v2
            }
          });
        }
      }
    );

    watch(
      [
        () =>
          endpointStatusCode.value === EndpointStatus.connected &&
          store.state.network.status === "connected",
        () => windowWidth.value,
        () => windowHeight.value
      ],
      ([v1, v2, v3]) => {
        if (v1 && v2 && v3) {
          store.dispatch("session/sendJsonMessage", {
            message: {
              type: MessageType.windowResolution,
              resolution: {
                width: v2,
                height: v3
              }
            }
          });
        }
      }
    );

    watch(
      [
        () =>
          endpointStatusCode.value === EndpointStatus.connected &&
          store.state.network.status === "connected",
        () => isSelfViewVisible.value
      ],
      ([v1, v2]) => {
        if (v1) {
          store.dispatch("session/sendJsonMessage", {
            message: {
              type: v2 ? MessageType.selfViewShown : MessageType.selfViewHidden
            }
          });
        }
      }
    );

    const geolocationWatchId = ref<number | null>(null),
      geolocation = ref<{ latitude: number; longitude: number } | null>(null),
      clearGeolocationWatcher = () => {
        if (geolocationWatchId.value) {
          navigator.geolocation.clearWatch(geolocationWatchId.value);
          geolocationWatchId.value = null;
          geolocation.value = null;
        }
      };

    watch(
      () =>
        endpointStatusCode.value === EndpointStatus.connected &&
        store.state.network.status === "connected" &&
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.startGeolocationSharing
        ),
      v => {
        if (v) {
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.startGeolocationSharing
          );

          const errCb = (err?: PositionError) => {
            console.error("Can not get geolocation: ", err);
            showToastError(i18n.global.t("call.error.geolocation"));
          };

          if (!navigator?.geolocation?.watchPosition) {
            errCb();
            return;
          }

          geolocationWatchId.value = navigator.geolocation.watchPosition(
            p => {
              if (
                _.isEqual(
                  _.pick(p.coords, ["latitude", "longitude"]),
                  geolocation.value
                )
              ) {
                return;
              }

              geolocation.value = _.pick(p.coords, ["latitude", "longitude"]);

              store.dispatch("session/sendJsonMessage", {
                message: {
                  type: MessageType.presentableInfo,
                  format: "location-string",
                  data: geolocation.value
                }
              });
            },
            err => errCb(err)
          );
        }
      },
      { immediate: true }
    );

    onUnmounted(() => clearGeolocationWatcher());

    watch(
      () =>
        endpointStatusCode.value !== EndpointStatus.connected ||
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.stopGeolocationSharing
        ),
      v => {
        if (v) {
          clearGeolocationWatcher();
          _.forEach(
            [
              RequestedAction.stopGeolocationSharing,
              RequestedAction.startGeolocationSharing
            ],
            a => store.commit("session/UNSET_REQUESTED_ACTION", a)
          );
        }
      },
      { immediate: true }
    );

    const resizeWindow = (preset: WindowSizePreset) =>
      sendParentWindowMessage({
        type: "windowResize",
        preset
      });

    watch(
      () =>
        endpointStatusCode.value === EndpointStatus.connected &&
        store.state.network.status === "connected" &&
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.setWindowSize
        ),
      v => {
        if (v) {
          const preset = _.find(
            requestedRemoteActions.value,
            v => v.action === RequestedAction.setWindowSize
          )!.payload as WindowSizePreset;

          resizeWindow(preset);

          handleRemoteActionRequestApprove(RequestedAction.setWindowSize);

          windowSizePreset.value = preset;
        }
      },
      { immediate: true }
    );

    watch(
      () =>
        endpointStatusCode.value === EndpointStatus.connected &&
        store.state.network.status === "connected" &&
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.setParentWindowUrl
        ),
      v => {
        if (v) {
          const url = _.find(
            requestedRemoteActions.value,
            v => v.action === RequestedAction.setParentWindowUrl
          )!.payload!.url as string;

          sendParentWindowMessage({
            type: "setWindowUrl",
            url
          });

          handleRemoteActionRequestApprove(RequestedAction.setParentWindowUrl);
        }
      },
      { immediate: true }
    );

    watch(
      () =>
        endpointStatusCode.value === EndpointStatus.connected &&
        store.state.network.status === "connected" &&
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.setAudioDevicesVolume
        ),
      async v => {
        if (v) {
          const volume = _.find(
            requestedRemoteActions.value,
            v => v.action === RequestedAction.setAudioDevicesVolume
          )!.payload as AudioDevicesVolumeDto;

          handleRemoteActionRequestApprove(
            RequestedAction.setAudioDevicesVolume
          );

          try {
            await store.dispatch("session/mediaDevices/setAudioVolume", volume);
          } catch (err) {
            showFailedRequestToastError(err);
          }
        }
      },
      { immediate: true }
    );

    const isCameraSnapshotButtonVisible = ref(false);

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.showCameraSnapshotButton
        ),
      v => {
        if (v) {
          handleRemoteActionRequestApprove(
            RequestedAction.showCameraSnapshotButton
          );

          isCameraSnapshotButtonVisible.value = true;
        }
      },
      { immediate: true }
    );
    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideCameraSnapshotButton
        ),
      v => {
        if (v) {
          handleRemoteActionRequestApprove(
            RequestedAction.hideCameraSnapshotButton
          );

          isCameraSnapshotButtonVisible.value = false;
        }
      },
      { immediate: true }
    );

    // for webex telephony when 3-rd member joined and aspect ratio is 'cover', the 3-rd member video can be cropped
    // also used for remote screen sharing
    const isAspectRatioContainForced = computed(() => {
      if (aspectRatio.value === AspectRatioMode.contain) {
        return false;
      }
      if (fullscreenImage.value?.aspectRatio === "contain") {
        return true;
      }
      if (remoteShareVideoStream.value && !isKioskPortrait.value) {
        return true;
      }
      if (telephonyType.value !== TelephonyType.webex) {
        return false;
      }
      if (!windowAspectRatio.value || !remoteVideoAspectRatio.value) {
        return false;
      }
      return windowAspectRatio.value! > remoteVideoAspectRatio.value!;
    });

    const callStartedAt = ref();

    watch(
      () => endpointStatusCode.value === EndpointStatus.connected,
      val => {
        callStartedAt.value = val ? moment().unix() : null;
      },
      { immediate: true }
    );

    const isBottomPanelVisible = ref<boolean>();

    let bottomPanelVisibilityTimer: number | null = null;
    const clearBottomPanelVisibilityTimer = () =>
        window.clearTimeout(bottomPanelVisibilityTimer ?? undefined),
      restartBottomPanelVisibilityTimer = () => {
        isBottomPanelVisible.value = true;
        clearBottomPanelVisibilityTimer();
        bottomPanelVisibilityTimer = window.setTimeout(
          () => (isBottomPanelVisible.value = false),
          3000
        );
      };

    watch(
      () => activeScreen.value === Screen.endCall,
      v => {
        if (v) {
          isBottomPanelVisible.value = false;
          clearBottomPanelVisibilityTimer();
        } else {
          restartBottomPanelVisibilityTimer();
        }
      },
      { immediate: true }
    );

    watch(
      () => isLocalVideoFullscreen.value,
      v => {
        if (v) {
          isBottomPanelVisible.value = false;
          clearBottomPanelVisibilityTimer();
        } else {
          restartBottomPanelVisibilityTimer();
        }
      },
      { immediate: true }
    );

    watch(
      () => activeScreen.value === Screen.calling,
      v => {
        if (v) {
          sendParentWindowMessage({
            type: "statusChanged",
            status: "placingCall"
          });
        }
      },
      { immediate: true }
    );
    watch(
      () => endpointStatusCode.value === EndpointStatus.connected,
      v => {
        if (v) {
          sendParentWindowMessage({
            type: "statusChanged",
            status: "onCall"
          });
          sendParentWindowMessage({ type: "getWindowUrl" });
        }
      },
      { immediate: true }
    );
    watch(
      () => endpointStatusCode.value === EndpointStatus.failure,
      v => {
        if (v) {
          sendParentWindowMessage({
            ...{
              type: "statusChanged",
              status: "failure"
            },
            ...(store.state.endpointStatus?.details
              ? { message: store.state.endpointStatus?.details as string }
              : {})
          });
          closeWindowWithDelay();
        }
      },
      { immediate: true }
    );
    watch(
      () =>
        store.state.queue.positionChangeReason ===
        CallQueuePositionChangedReason.noExperts,
      v => {
        if (v) {
          sendParentWindowMessage({
            type: "statusChanged",
            status: "noExperts"
          });
          closeWindowWithDelay();
        }
      },
      { immediate: true }
    );
    watch(
      () => activeScreen.value === Screen.endCall,
      v => {
        if (v) {
          sendParentWindowMessage({
            type: "statusChanged",
            status: "callEnded"
          });
          closeWindow();
        }
      },
      { immediate: true }
    );

    const visualHint = computed(() => store.state.session.visualHint),
      qrCode = computed((): QrCodeDTO => store.state.session.qrCode),
      textHint = computed((): TextHintDto => store.state.session.textHint),
      bulletList = computed(
        (): BulletListDto | null => store.state.session.bulletList
      ),
      tableHint = computed(
        (): TableHintDto | null => store.state.session.tableHint
      ),
      videoHint = computed(
        (): VideoHintDto | null => store.state.session.videoHint
      );

    const tempHintKey = ref(0);

    watch(
      () =>
        visualHint.value ??
        qrCode.value ??
        textHint.value ??
        bulletList.value ??
        tableHint.value ??
        videoHint.value ??
        isCameraSnapshotButtonVisible.value,
      v => {
        tempHintKey.value++;
        if (v && isWindowMinimized.value) {
          windowSizeBackPreset.value = windowSizePreset.value;
          resizeWindow("halfscreen");
        } else if (!v && windowSizeBackPreset.value) {
          resizeWindow(windowSizeBackPreset.value);
          windowSizeBackPreset.value = null;
        }
      },
      { immediate: true }
    );

    watch(
      () => [
        visualHint.value?.id,
        qrCode.value?.id,
        textHint.value?.id,
        bulletList.value?.id,
        tableHint.value?.id,
        videoHint.value?.id
      ],
      (newValues, oldValues) => {
        if (endpointStatusCode.value !== EndpointStatus.connected) {
          return;
        }

        _.forEach(newValues, (v, i) => {
          if (oldValues?.[i] && oldValues?.[i] !== v) {
            store.dispatch("session/sendJsonMessage", {
              message: {
                type: MessageType.presentableClosed,
                id: oldValues?.[i]
              }
            });
          }
        });
      },
      { immediate: true }
    );

    onBeforeUnmount(() => {
      if (isEmbedded.value) {
        closeWindow();
      }
      if (windowSizeBackPreset.value) {
        resizeWindow(windowSizeBackPreset.value);
      }
    });

    let cleanupDeviceListener: null | Function = null;

    watch(
      () =>
        telephonyType.value === TelephonyType.webrtc &&
        store.state.webrtc.streams.local instanceof MediaStream &&
        _.includes([Screen.calling], activeScreen.value),
      async v => {
        if (v) {
          cleanupDeviceListener?.();

          await refreshMediaInputs();

          const checkCallSessionUnavailability = () => {
            if (store.getters["webrtc/callSession"]) {
              console.log(
                "Call session already created, do not add 'devicechange' listener"
              );
              return false;
            }
            return true;
          };

          if (!checkCallSessionUnavailability()) {
            return;
          }

          cleanupDeviceListener = useEventListener(
            navigator.mediaDevices,
            "devicechange",
            async () => {
              console.log("Media device changed event emitted");

              const oldCameraId = cameraId.value;

              await refreshMediaInputs();

              if (
                activeScreen.value === Screen.calling &&
                checkCallSessionUnavailability() &&
                ((oldCameraId && oldCameraId !== cameraId.value) ||
                  !cameras.value.length)
              ) {
                console.log(`Active camera ${oldCameraId} disconnected`);

                cleanupDeviceListener?.();

                store.commit("webrtc/UNSET_STREAM", "local");

                const errMessage =
                  EndpointStatusDetails.mediaStreamsCreatingError;

                store.commit("webrtc/SET_STREAM", {
                  type: "local",
                  stream: new Error(errMessage)
                });

                store.dispatch("setEndpointStatus", {
                  status: EndpointStatus.failure,
                  details: errMessage
                });
              }
            },
            { passive: true }
          );
        }
      },
      { immediate: true }
    );

    // const subtitlesFontsizeCssVal = useCssVar("--subtitles-fontsize", document.documentElement),
    //     subtitlesFontsizeCssDefaultVal = subtitlesFontsizeCssVal.value;
    //
    // console.log([subtitlesFontsizeCssVal.value, subtitlesFontsizeCssDefaultVal])
    //
    // watchEffect(() => {
    //   if (activeScreen.value !== Screen.onCall) {
    //     subtitlesFontsizeCssVal.value = subtitlesFontsizeCssDefaultVal
    //
    //     console.log({subtitlesFontsizeCssVal: subtitlesFontsizeCssVal.value})
    //   }
    // })

    return {
      isBottomPanelVisible,
      restartBottomPanelVisibilityTimer,
      isCameraEnabled,
      isVideoOn,
      isOnHold,
      telephonyType,
      TelephonyType,
      localVideoRef,
      localVideoPreviewRef,
      remoteVideoRef,
      remoteAudioRef,
      remoteShareVideoRef,
      localVideoContainerRef,
      remoteVideoContainerRef,
      remoteAudioContainerRef,
      aspectRatio,
      isHangupButtonEnabled,
      isBrowserFrameVisible,
      isOpenUrlRequestVisible,
      openedUrl,
      openUrl,
      isHangupRequestVisible,
      isMicrophoneModeButtonVisible: computed(
        (): boolean =>
          isMediaInputSettingsAvailable.value && !!microphones.value?.length
      ),
      isMicModeButtonEnabled,
      handleSwitchMicrophoneModeClick: switchMicrophoneMode,
      isMicrophoneEnabled,
      handleDocumentInputChange,
      documentInputKey,
      documentInputRef,
      requestedRemoteActions,
      RequestedAction,
      handleRemoteActionRequestReject,
      handleRemoteActionRequestApprove,
      primaryMessage,
      secondaryMessage,
      route,
      topics: computed((): TopicDTO[] | null => store.state.topics.list),
      setTestLocalAndRemoteVideos,
      setTestRemoteViewConfig,
      setTestSharedScreenVideo,
      setTestVisualHint,
      setTestTextHint,
      setTestBulletList,
      setTestSuggestions,
      setTestTableHint,
      setTestVideoHint,
      setTestSubtitles,
      handleShowTextMessageFormClick: () =>
        store.commit("session/SET_REQUESTED_ACTION", {
          action: RequestedAction.showTextMessageForm
        }),
      handleShowPaintoverClick: () =>
        store.commit("session/SET_REQUESTED_ACTION", {
          action: RequestedAction.showDrawingPad,
          payload: {
            background: {
              url:
                "https://as1.ftcdn.net/v2/jpg/02/24/24/06/1000_F_224240638_9cg17hGtJw54J4kLjLNsU6EfYiBoJUcI.jpg",
              opacity: 0.5
            }
          }
        }),
      remoteViewConfig,
      remoteViewCustomBackground,
      RobotType,
      handleHangupClick: async () => await hangup(),
      localVideoContainerMouseLeavesCount: ref(0),
      config,
      textColor: computed(() => config.value?.sessionTextColor ?? "white"),
      backgroundColor: computed(() => config.value?.sessionBackgroundColor),
      backgroundImage: computed(() => {
        if (!isKioskType.value) {
          return null;
        }
        const img =
          config.value.sessionPageBackgroundImage ||
          config.value.appBackgroundImage;
        if (!img) {
          return null;
        }
        return _.startsWith(img, "url")
          ? img
          : `url('${
              _.startsWith(img, "http") ? "" : config.value.publicPath
            }${img}')`;
      }),
      isRtl: computed(() => isLangRtl(appLocale.value)),
      AspectRatioMode,
      ButtonType,
      ModalPosition,
      ModalSize,
      remoteShareVideoStream,
      isSafari,
      isSharedFileModalVisible,
      sharedFileLink,
      handleSharedFileDismissClick: () => {
        isSharedFileModalVisible.value = false;
        if (isSafari) {
          URL.revokeObjectURL(sharedFileLink.value!);
        }
        store.commit("sharing/UNSET_FILE", "remote");
      },
      handleSharedFileDownloadClick: () =>
        (isSharedFileModalVisible.value = false),
      sharedFile,
      isInteractiveSharingEnabled,
      isMobileKeyboardEnabled,
      mobileKeyboardInputValue,
      inputKey,
      handleRemoteVideoResize: (e: Event) =>
        (remoteVideoAspectRatio.value =
          _.get(e, "target.videoWidth") / _.get(e, "target.videoHeight")),
      handleMobileKeyboardInput,
      remoteVideoContainerStyleObject,
      endpointStatusCode,
      EndpointStatus,
      queuePosition,
      isThrownFromQueueUrgently,
      sessionInfo,
      topicTitle,
      isSettingsModalVisible,
      cameras,
      microphones,
      cameraId,
      microphoneId,
      activeCameraType,
      isLocalVideoFullscreen,
      isLowPerformanceAndroid,
      isLowPerformanceModalVisible,
      handleFeedbackClick,
      documentSvg: `<svg
                  width="50"
                  height="50"
                  viewBox="0 0 24 24"
                  xml:space="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="white"
                >
                  <g>
                    <path
                      d="M20,6v12H4V6H20 M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4L20,4z"
                    />
                  </g>
                  <polygon points="8,10 12,13 14,12 18,14.4 18,16 6,16 6,12 " />
                  <circle cx="16.5" cy="9.5" r="1.5" />
                </svg>`,
      visualHint,
      qrCode,
      textHint,
      bulletList,
      tableHint,
      videoHint,
      tempHintKey,
      suggestions: computed((): string[] => store.state.session.suggestions),
      isCameraIndicationIconVisible: computed(
        () =>
          endpointStatusCode.value === EndpointStatus.connected &&
          !remoteShareVideoStream.value &&
          isVideoOn.value
      ),
      isThankPageDisplayingForced,
      jwt: computed(() => store.state.auth.jwt),
      activeScreen,
      Screen,
      errorMessage,
      isLocalVideoPreviewVisible: computed(
        () =>
          ((telephonyType.value === TelephonyType.webex &&
            store.state.webex.streams.localVideo) ||
            (telephonyType.value === TelephonyType.webrtc &&
              store.state.webrtc.streams.local)) &&
          activeScreen.value === Screen.calling
      ),
      isMediaInputsAccessHintVisible: computed(
        () =>
          activeScreen.value === Screen.calling &&
          !(isKioskOs.value || isWebKiosk.value) &&
          !(
            (telephonyType.value === TelephonyType.webex &&
              store.state.webex.streams.localVideo) ||
            (telephonyType.value === TelephonyType.webrtc &&
              store.state.webrtc.streams.local)
          )
      ),
      redirectTo: computed(
        () =>
          getRouteQueryValue("redirect") ??
          getProperty("after.call.redirect.url") ??
          null
      ),
      isSettingsButtonVisible,
      isCameraToggleButtonVisible: computed(
        (): boolean =>
          endpointStatusCode.value === EndpointStatus.connected &&
          !!cameras.value?.length
      ),
      isCameraModeButtonVisible: computed(
        (): boolean => endpointStatusCode.value === EndpointStatus.connected
      ),
      isCallSharingButtonVisible: computed(
        (): boolean =>
          endpointStatusCode.value === EndpointStatus.connected &&
          !!sharedLink.value
      ),
      handleCallSharingClick: () => {
        copyText(sharedLink.value, undefined, (error: any, event: any) =>
          error
            ? showToastError(i18n.global.t("call.error.callSharing"))
            : showToastSuccess(i18n.global.t("call.success.callSharing"))
        );
        isSettingsModalVisible.value = false;
      },
      handleCameraEnableClick: async () =>
        await store.dispatch("session/mediaDevices/enableCamera"),
      handleCameraDisableClick: async () =>
        await store.dispatch("session/mediaDevices/disableCamera"),
      isAspectRatioContainForced,
      isSelfViewVisible,
      callStartedAt,
      mime,
      fullscreenImage,
      appLocale,
      appLocales: computed(() => {
        const appLocalesOrder = store.state.config.config.appLocalesOrder;

        return _.fromPairs(
          _.map(
            _.sortBy(
              _.filter(_.keys(appLocalesOrder), l => +appLocalesOrder[l] >= 0),
              l => +appLocalesOrder[l]
            ),
            l => [l, ISO6391.getNativeName(l)]
          )
        );
      }),
      handleAppLocaleSelect: (locale: AppLocale) => {
        store.commit("config/PATCH_CONFIG", { appLocale: locale });

        const sourceLanguage: HumanSpeechLanguage | null =
          store.state.session.sourceLanguage ??
          getProperty("aws.translation.source.language") ??
          null;

        if (
          sourceLanguage &&
          _.first(_.split(sourceLanguage, "-")) === locale
        ) {
          return;
        }

        const matched = {
          en: HumanSpeechLanguage["en-US"],
          ca: HumanSpeechLanguage["ca-ES"],
          es: HumanSpeechLanguage["es-ES"],
          he: HumanSpeechLanguage["he-IL"],
          pt: HumanSpeechLanguage["pt-PT"],
          ja: HumanSpeechLanguage["ja-JP"],
          fr: HumanSpeechLanguage["fr-FR"]
        };

        store.commit("session/SET_SOURCE_LANGUAGE", matched[locale]);
      },
      isEmbedded,
      isKioskType,
      isKioskPortrait,
      timestamp,
      moment,
      getProperty,
      isFeedbackFormEnabled,
      isFeedbackFormVisible,
      isFeedbackCreating,
      windowSizePreset,
      sendParentWindowMessage,
      isWindowMinimized,
      handleCloseClick: async () => {
        try {
          if (isHangupButtonEnabled.value) {
            await hangup();
          }
        } finally {
          closeWindow();
        }
      },
      isCameraSnapshotButtonVisible,
      handleTakeCameraSnapshotClick: async () => {
        isCameraSnapshotButtonVisible.value = false;
        await takeCameraSnapshot();
      },
      appType,
      isFrameless: computed(
        () =>
          appType.value === ClientAppType.embedded &&
          config.value.embedded?.frameless
      ),
      ClientAppType,
      animatedCharacterState,
      ..._.pick(_, [
        "filter",
        "startCase",
        "startsWith",
        "kebabCase",
        "find",
        "range",
        "concat",
        "keys"
      ]),
      ...(props as {
        isReconnectingScreenVisible?: false;
        isContentHidden?: false;
      })
    };
  }
};
</script>
<style lang="scss">
@import "../assets/styles/breakpoints.module";
@import "../assets/styles/frame-conrol-bar.scss";
@import "../assets/styles/top-panel.scss";
@import "../assets/styles/Call.scss";

@import "../assets/styles/conversation-status.scss";
@import "../assets/styles/kiosk-portrait-30inch/conversation-status.scss";
</style>
